<template>
    <div class="columns is-mobile is-centered has-background-primary p-2">
        <h1 class="title is-4 has-text-white"><i class="fas fa-arrow-right-from-bracket"></i> &nbsp; LAVORO</h1>
    </div>

    <div class="box" @submit.prevent="" v-if="formAttivo">

        <div class="columns">
            <div class="column">
                <div class="field buttons">
                    <button class="button is-light"  @click="bAnnulla" :disabled="idFaseSelezionata || idContabileSelezionata || idDicoSelezionata || !lavoroDaAggiornare">Annulla</button>
                    <button class="button is-primary" @click="bSalva" :disabled="idFaseSelezionata || idContabileSelezionata || idDicoSelezionata || !lavoroDaAggiornare">Salva</button>
                </div>
            </div>
            <div class="column" v-if="schermoLargo">
                <p>
                    <a @click="bCambiaCliente()" title="Cambia cliente"><i class="fas fa-user"></i> &lt; &ndash; &gt; <i class="fas fa-user"></i></a>
                </p>
            </div>
            <div class="column" v-if="schermoLargo">
                <p>
                    <a @click="gestisciSelezioneElemento({tipo: 'cliente', idCliente: props.idCliente})" title="Vai al cliente">
                        <i class="fas fa-user"></i> &nbsp; {{ generaStringaCliente(props.idCliente) }}
                    </a>
                </p>
            </div>
            <div class="column" v-if="props.idLavoro!=-1 && schermoLargo">
                <p>
                    <a><i class="fas fa-arrow-right-from-bracket"></i> &nbsp; {{ leggiInfoDB(dbClienti[props.idCliente]?.lavori?.[props.idLavoro])?.stringaLavoroCorta }}</a>
                </p>
            </div>
            <div class="column" v-if="schermoLargo">
                <div class="field buttons is-right">
                    <button class="button is-danger" @click="bElimina" v-if="idLavoroSelezionato!=-1 && permettiElimina" :disabled="idFaseSelezionata || idContabileSelezionata || idDicoSelezionata">Elimina</button>
                </div>
            </div>
        </div>

        <div class="blocco-scroll">

            <div class="columns" v-if="!schermoLargo">
                <div class="column">
                    <p>
                        <a @click="bCambiaCliente()" title="Cambia cliente"><i class="fas fa-user"></i> &lt; &ndash; &gt; <i class="fas fa-user"></i></a>
                    </p>
                </div>
                <div class="column">
                    <p>
                        <a @click="gestisciSelezioneElemento({tipo: 'cliente', idCliente: props.idCliente})" title="Vai al cliente"><i class="fas fa-user"></i> &nbsp; {{ generaStringaCliente(props.idCliente) }}</a>
                    </p>
                </div>
                <div class="column" v-if="props.idLavoro!=-1">
                    <p>
                        <a><i class="fas fa-arrow-right-from-bracket"></i> &nbsp; {{ leggiInfoDB(dbClienti[props.idCliente]?.lavori?.[props.idLavoro])?.stringaLavoroCorta }}</a>
                    </p>
                </div>
            </div>

            <div class="tabs">
                <ul>
                    <li :class="{'is-active': statoInterfaccia.formLavoroTab == 1}">
                        <a @click="bSelezionaTAb(1)">
                            <span>Lavoro</span>
                        </a>
                    </li>
                    <li :class="{'is-active': statoInterfaccia.formLavoroTab == 2}">
                        <a @click="bSelezionaTAb(2)">
                            <span>Amministrazione</span>
                        </a>
                    </li>
                    <li :class="{'is-active': statoInterfaccia.formLavoroTab == 3}">
                        <a @click="bSelezionaTAb(3)">
                            <span>Fasi</span>
                        </a>
                    </li>
                    <li :class="{'is-active': statoInterfaccia.formLavoroTab == 4}">
                        <a @click="bSelezionaTAb(4)">
                            <span>DiCo</span>
                        </a>
                    </li>
                    <li :class="{'is-active': statoInterfaccia.formLavoroTab == 5}" v-if="impostazioniGenerali.mostraTest">
                        <a @click="bSelezionaTAb(5)">
                            <span>Contabilità</span>
                        </a>
                    </li>
                    <li :class="{'is-active': statoInterfaccia.formLavoroTab == 7}" v-if="impostazioniGenerali.mostraTest">
                        <a @click="bSelezionaTAb(7)">
                            <span>Costi</span>
                        </a>
                    </li>
                    <li :class="{'is-active': statoInterfaccia.formLavoroTab == 6}">
                        <a @click="bSelezionaTAb(6)">
                            <span>Contatti</span>
                        </a>
                    </li>
                    <li :class="{'is-active': statoInterfaccia.formLavoroTab == 8}">
                        <a @click="bSelezionaTAb(8)">
                            <span>Area cliente</span>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="columns" v-if="statoInterfaccia.formLavoroTab==1">
                <div class="column is-1">
                    <CampoNumero @valoreCambiato="lavoroModifica"
                        :valore=lavoroSelezionato.codice
                        identificativo="codice"
                        etichetta="Codice"
                        tipo="Intero"/>
                </div>
                <div class="column is-8">
                    <div class="field">
                        <label class="label">Oggetto</label>
                        <div class="control">
                            <input class="input" type="text" v-model="lavoroSelezionato.oggetto" @change="lavoroModifica(lavoroSelezionato.oggetto, 'oggetto')">
                        </div>
                    </div>
                </div>
                <div class="column is-3">
                    <CampoData @valoreCambiato="lavoroModifica"
                        :valore=lavoroSelezionato.dataOrdine
                        identificativo="dataOrdine"
                        etichetta="Data ordine"/>
                </div>
            </div>
            <div class="columns" v-if="statoInterfaccia.formLavoroTab==1">
                <div class="column is-4">
                    <div class="field">
                        <label class="label">Progettista</label>
                        <div class="control">
                            <input class="input" type="text" v-model="lavoroSelezionato.progettista"  @change="lavoroModifica(lavoroSelezionato.progettista, 'progettista')">
                        </div>
                    </div>
                </div>
                <div class="column is-3">
                    <label class="label">Indirizzo</label>
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <input class="input" type="text" v-model="lavoroSelezionato.indirizzo"  @change="lavoroModifica(lavoroSelezionato.indirizzo, 'indirizzo')">
                        </div>
                        <div class="control">
                            <button class="button is-primary" @click="apriLinkLuogo(lavoroSelezionato.indirizzo)">
                                <p><i class="fas fa-location-dot"></i></p>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="column is-1">
                    <div class="field">
                        <label class="label">&nbsp;</label>
                        <button class="button is-primary is-outlined" @click="bCopiaIndirizzoAnagrafica()">
                            <span class="icon" title="Copia indirizzo dall'anagrafica"><i class="fas fa-file-import"></i></span>
                        </button>
                    </div>
                </div>
                <div class="column is-3">
                    <label class="label">Posizione</label>
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <input class="input" type="text" v-model="lavoroSelezionato.luogo"  @change="lavoroModifica(lavoroSelezionato.luogo, 'luogo')">
                        </div>
                        <div class="control">
                            <button class="button is-primary" @click="apriLinkLuogo(lavoroSelezionato.luogo)">
                                <p><i class="fas fa-location-dot"></i></p>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="column is-1">
                    <div class="field">
                        <label class="label">&nbsp;</label>
                        <button class="button is-primary is-outlined" @click="bCopiaPosizione()">
                            <span class="icon" title="Copia indirizzo e posizione"><i class="fas fa-copy"></i></span>
                        </button>
                        &nbsp;
                        <button class="button is-primary is-outlined" @click="bIncollaPosizione()" :disabled="!('posizione' in copiaTrasporto)">
                            <span class="icon" title="Incolla indirizzo e posizione"><i class="fas fa-paste"></i></span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="columns" v-if="statoInterfaccia.formLavoroTab==1">
                <div class="column is-12">
                    <div class="field">
                        <label class="label">Tag</label>
                        <div class="control">
                            <div class="tags mb-2" v-if="lavoroSelezionato.tags && lavoroSelezionato.tags.length > 0">
                                <span class="tag is-primary is-light is-medium" v-for="(tag, index) in lavoroSelezionato.tags" :key="index">
                                    {{ tag }}
                                    <button class="delete is-small" @click="bRimuoviTag(index)"></button>
                                </span>
                            </div>
                            <div class="field has-addons">
                                <div class="control is-expanded">
                                    <input class="input" type="text" v-model="nuovoTag" @keyup.enter="bAggiungiTag" @change="bAggiungiTag" list="lista-tags-lavori" placeholder="Inserisci un nuovo tag e premi Invio...">
                                    <datalist id="lista-tags-lavori" v-if="tagsGlobaliOrdinati.length > 0">
                                        <option v-for="tagGlobale in tagsGlobaliOrdinati" :key="tagGlobale" :value="tagGlobale"></option>
                                    </datalist>
                                </div>
                                <div class="control">
                                    <button class="button is-primary is-outlined" @click="bAggiungiTag" title="Aggiungi Tag">
                                        <span class="icon"><i class="fas fa-plus"></i></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="columns" v-if="statoInterfaccia.formLavoroTab==1">
                <div class="column">
                    <div class="field">
                        <label class="label">Note lavoro</label>
                        <div class="control">
                            <textarea class="textarea" placeholder="Note lavoro"  rows="3" v-model="lavoroSelezionato.noteLavoro"  @change="lavoroModifica(lavoroSelezionato.noteLavoro, 'noteLavoro')"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns" v-if="statoInterfaccia.formLavoroTab==2">
                <div class="column is-4">
                    <CampoTendina @valoreCambiato="(valore)=>lavoroModifica(valore, 'detrazione')"
                        :valore=lavoroSelezionato.detrazione
                        idTendina="lavoro.detrazione"
                        etichetta="Detrazione"/>
                </div>
                <div class="column is-4">
                    <CampoTendina @valoreCambiato="(valore)=>lavoroModifica(valore, 'iva')"
                        :valore=lavoroSelezionato.iva
                        idTendina="lavoro.iva"
                        etichetta="Iva"/>
                </div>
                <div class="column is-4">
                    <div class="field">
                        <label class="label">Codice catasto</label>
                        <div class="control">
                            <input class="input" type="text" v-model="lavoroSelezionato.codCatasto"  @change="lavoroModifica(lavoroSelezionato.codCatasto, 'codCatasto')">
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns" v-if="statoInterfaccia.formLavoroTab==2">
                <div class="column">
                    <div class="field">
                        <label class="label">Note amministrazione</label>
                        <div class="control">
                            <textarea class="textarea" placeholder="Note amministrazione"  rows="3" v-model="lavoroSelezionato.noteAmministrazione"  @change="lavoroModifica(lavoroSelezionato.noteAmministrazione, 'noteAmministrazione')"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <FormFase
                :idCliente=leggiInfoDB(lavoroSelezionato).idCliente
                :idLavoro=leggiInfoDB(lavoroSelezionato).id
                :idFase=idFaseSelezionata
                vista="ridotta"
                @modificaElementoInCorso="bBloccaInterfaccia"
                @elementoSelezionato="gestisciSelezioneElemento"
                v-if="statoInterfaccia.formLavoroTab==3 && idFaseSelezionata!=null"/>
            <ElencoFasi
                :bottoneAggiungiVisibile=true
                :cliente=leggiInfoDB(lavoroSelezionato).idCliente
                :lavoro=leggiInfoDB(lavoroSelezionato).id
                :campoRicercaVisibile=false
                :titoloVisibile=false
                @elementoSelezionato="gestisciSelezioneElemento"
                v-if="statoInterfaccia.formLavoroTab==3 && leggiInfoDB(lavoroSelezionato).id"/>
            <FormDico
                :idLavoro=leggiInfoDB(lavoroSelezionato).id
                :idCliente=leggiInfoDB(lavoroSelezionato).idCliente
                :idDico=idDicoSelezionata
                vista="ridotta"
                @modificaElementoInCorso="bBloccaInterfaccia"
                @elementoSelezionato="gestisciSelezioneElemento"
                v-if="statoInterfaccia.formLavoroTab==4 && idDicoSelezionata!=null"/>
            <ElencoDico
                :bottoneAggiungiVisibile=true
                :cliente=leggiInfoDB(lavoroSelezionato).idCliente
                :lavoro=leggiInfoDB(lavoroSelezionato).id
                :campoRicercaVisibile=false
                :titoloVisibile=false
                @elementoSelezionato="gestisciSelezioneElemento"
                v-if="statoInterfaccia.formLavoroTab==4 && leggiInfoDB(lavoroSelezionato).id"/>
            <FormContabile
                :idLavoro=leggiInfoDB(lavoroSelezionato).id
                :idCliente=leggiInfoDB(lavoroSelezionato).idCliente
                :idContabile=idContabileSelezionata
                vista="ridotta"
                @modificaElementoInCorso="bBloccaInterfaccia"
                @elementoSelezionato="gestisciSelezioneElemento"
                v-if="statoInterfaccia.formLavoroTab==5 && idContabileSelezionata!=null"/>
            <ElencoContabili
                :bottoneAggiungiVisibile=true
                :cliente=leggiInfoDB(lavoroSelezionato).idCliente
                :lavoro=leggiInfoDB(lavoroSelezionato).id
                :campoRicercaVisibile=false
                :titoloVisibile=false
                @elementoSelezionato="gestisciSelezioneElemento"
                v-if="statoInterfaccia.formLavoroTab==5 && leggiInfoDB(lavoroSelezionato).id"/>
            <FormCosto
                :idLavoro=leggiInfoDB(lavoroSelezionato).id
                :idCliente=leggiInfoDB(lavoroSelezionato).idCliente
                :idCosto=idCostoSelezionato
                :titoloVisibile=false
                vista="subordinata"
                @modificaElementoInCorso="bBloccaInterfaccia"
                @elementoSelezionato="gestisciSelezioneElemento"
                v-if="statoInterfaccia.formLavoroTab==7 && idCostoSelezionato!=null"/>
            <ElencoCosti
                :testoDaCercare=testoRicercaCosti
                :data-inizio=dataInizioRicercaCosti
                :data-fine=dataFineRicercaCosti
                :bottoneAggiungiVisibile=true
                :cliente=leggiInfoDB(lavoroSelezionato).idCliente
                :lavoro=leggiInfoDB(lavoroSelezionato).id
                :campoRicercaVisibile=true
                :titoloVisibile=false
                @statoInterfacciaCambiato="cambiaStatoInterfaccia"
                @elementoSelezionato="gestisciSelezioneElemento"
                v-if="statoInterfaccia.formLavoroTab==7 && leggiInfoDB(lavoroSelezionato).id"/>
            <ElencoContatti
                :bottoneAggiungiVisibile=true
                :cliente=leggiInfoDB(lavoroSelezionato).idCliente
                :lavoro=leggiInfoDB(lavoroSelezionato).id
                :campoRicercaVisibile=false
                :titoloVisibile=false
                @elementoSelezionato="gestisciSelezioneElemento"
                @copiaContatti="bCopiaContatti"
                @incollaContatti="bIncollaContatti"
                v-if="statoInterfaccia.formLavoroTab==6 && leggiInfoDB(lavoroSelezionato).id"/>

            <!-- SEZIONE AREA RISERVATA CLIENTE -->
            <div class="box mt-5" v-if="statoInterfaccia.formLavoroTab==8">
                <!-- Sub-tabs per Area Riservata Cliente -->
                <div class="tabs is-boxed mb-4">
                    <ul>
                        <li :class="{'is-active': subTabAreaCliente == 'accesso'}">
                            <a @click="subTabAreaCliente = 'accesso'">
                                <span class="icon is-small"><i class="fas fa-link"></i></span>
                                <span>Accesso</span>
                            </a>
                        </li>
                        <li :class="{'is-active': subTabAreaCliente == 'questionari'}">
                            <a @click="subTabAreaCliente = 'questionari'">
                                <span class="icon is-small"><i class="fas fa-file-invoice"></i></span>
                                <span>Questionari</span>
                            </a>
                        </li>
                        <li :class="{'is-active': subTabAreaCliente == 'documenti'}">
                            <a @click="subTabAreaCliente = 'documenti'">
                                <span class="icon is-small"><i class="fas fa-folder-open"></i></span>
                                <span>Documenti</span>
                            </a>
                        </li>
                        <li :class="{'is-active': subTabAreaCliente == 'fasi'}">
                            <a @click="subTabAreaCliente = 'fasi'">
                                <span class="icon is-small"><i class="fas fa-tasks"></i></span>
                                <span>Attività</span>
                            </a>
                        </li>
                    </ul>
                </div>

                <!-- SUBTAB 0: ACCESSO E LINK (Link, Scadenza, Bottoni di controllo, Archivio Storico) -->
                <div v-if="subTabAreaCliente == 'accesso'">
                    <!-- CASO 1: Area Riservata Generata (Attiva o Disattivata) -->
                    <div v-if="areaRiservataAttiva" class="box has-background-white animate__animated animate__fadeIn">
                        <div class="is-flex is-justify-content-space-between is-align-items-center mb-2">
                            <p>
                                <strong v-if="areaRiservataAttiva.statoLavoro === 'disattivato'" class="has-text-danger">
                                    Link Disattivato &nbsp;<i class="fas fa-ban"></i>
                                </strong>
                                <strong v-else class="has-text-success">
                                    Link Attivo &nbsp;<i class="fas fa-check-circle"></i>
                                </strong>
                            </p>
                        </div>
                        
                        <div class="field has-addons mb-3">
                            <div class="control is-expanded">
                                <input class="input" type="text" readonly :value="generalinkEsterno(areaRiservataAttiva.token)" :style="areaRiservataAttiva.statoLavoro === 'disattivato' ? 'text-decoration: line-through; opacity: 0.7;' : ''">
                            </div>
                            <div class="control">
                                <button class="button is-primary" @click="copiaLinkClipboard(areaRiservataAttiva.token)" title="Copia link" :disabled="areaRiservataAttiva.statoLavoro === 'disattivato'">
                                    <span class="icon"><i class="fas fa-copy"></i></span>
                                </button>
                            </div>
                        </div>

                        <div class="columns is-multiline is-mobile is-align-items-flex-end mb-2">
                            <div class="column is-4-tablet is-12-mobile">
                                <CampoData 
                                    :valore="areaRiservataAttiva.dataScadenza"
                                    identificativo="dataScadenza"
                                    etichetta="Data di disattivazione"
                                    titolo="Modifica data di disattivazione link area riservata"
                                    @valoreCambiato="modificaDataDisattivazione"
                                />
                            </div>
                            <div class="column is-8-tablet is-12-mobile">
                                <div class="buttons is-right">
                                    <button v-if="areaRiservataAttiva.statoLavoro !== 'disattivato'" class="button is-warning" :class="{'is-loading': caricamentoToken}" @click="toggleStatoAreaRiservata(areaRiservataAttiva.token, 'disattivato')">
                                        <span class="icon"><i class="fas fa-pause"></i></span>
                                        <span>Disattiva</span>
                                    </button>
                                    <button v-else class="button is-success" :class="{'is-loading': caricamentoToken}" @click="toggleStatoAreaRiservata(areaRiservataAttiva.token, 'attivo')">
                                        <span class="icon"><i class="fas fa-play"></i></span>
                                        <span>Riattiva</span>
                                    </button>
                                    
                                    <button class="button is-info is-outlined" :class="{'is-loading': caricamentoToken}" @click="rigeneraAreaRiservata(areaRiservataAttiva.token)" title="Clona contenuto in un nuovo link">
                                        <span class="icon"><i class="fas fa-sync-alt"></i></span>
                                        <span>Rigenera codice</span>
                                    </button>
                                    
                                    <button v-if="permettiElimina" class="button is-danger is-outlined" :class="{'is-loading': caricamentoToken}" @click="eliminaAreaRiservata(areaRiservataAttiva.token)" title="Elimina permanentemente l'area e i suoi dati">
                                        <span class="icon"><i class="fas fa-trash"></i></span>
                                        <span>Elimina</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- CASO 2: Nessuna Area Attiva (Area Chiusa) -->
                    <div v-else class="box has-background-white animate__animated animate__fadeIn">
                        <p class="mb-3">Nessun link di accesso generato per questo cantiere.</p>
                        
                        <div class="columns is-align-items-flex-end is-mobile mb-2">
                            <div class="column is-4-tablet is-7-mobile">
                                <CampoData 
                                    :valore="dataDisattivazioneIniziale"
                                    identificativo="dataDisattivazioneIniziale"
                                    etichetta="Data di disattivazione"
                                    titolo="Data di disattivazione link area riservata"
                                    @valoreCambiato="(data) => dataDisattivazioneIniziale = data"
                                />
                            </div>
                            <div class="column">
                                <div class="field">
                                    <button class="button is-primary" :class="{'is-loading': caricamentoToken}" @click="creaNuovaAreaRiservata(null)">
                                        Genera Link Invito
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- SUBTAB 1: QUESTIONARI -->
                <div v-if="subTabAreaCliente == 'questionari'">
                    <div v-if="!areaRiservataAttiva" class="notification is-warning is-light mb-3">
                        <p>Nessun link di accesso attivo per questo cantiere. Attiva l'area riservata nel tab <strong>"Accesso"</strong> per creare o gestire i questionari.</p>
                    </div>
                    <template v-else>
                        <!-- Importazione Questionario da Template -->
                        <div class="field has-addons mb-4" v-if="impostazioniGenerali.questionariPredefiniti && Object.keys(impostazioniGenerali.questionariPredefiniti).length > 0">
                            <div class="control is-expanded">
                                <div class="select is-small is-fullwidth">
                                    <select v-model="nuovoQuestionarioTemplateKey">
                                        <option value="" disabled>Seleziona un template questionario...</option>
                                        <option v-for="(tpl, key) in impostazioniGenerali.questionariPredefiniti" :key="key" :value="key">
                                            {{ tpl.titolo }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="control">
                                <button class="button is-small is-primary" @click="importaQuestionario" :disabled="!nuovoQuestionarioTemplateKey">
                                    Importa Questionario
                                </button>
                            </div>
                        </div>

                        <!-- Lista questionari attivi -->
                        <div v-if="!areaRiservataAttiva.questionari || Object.keys(areaRiservataAttiva.questionari).length === 0" class="notification is-info is-light is-small py-2 mb-2">
                            Nessun questionario caricato per questo cliente.
                        </div>
                                                <div v-for="{ quest, idQuest } in questionariOrdinati" :key="idQuest" class="box has-background-white mb-4 p-4">
                            <div 
                                class="is-flex is-align-items-center is-justify-content-space-between is-clickable"
                                :class="{ 'mb-3 pb-2': questionarioApertoId === idQuest }"
                                :style="questionarioApertoId === idQuest ? 'border-bottom: 1px solid #eee; cursor: pointer;' : 'cursor: pointer;'"
                                @click="toggleQuestionarioAperto(idQuest)"
                            >
                                <div class="is-flex is-align-items-center">
                                    <span class="icon mr-2 has-text-grey">
                                        <i class="fas" :class="questionarioApertoId === idQuest ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                    </span>
                                    <div>
                                        <template v-if="quest.stato === 'locale' || quest.stato === 'bozza'">
                                            <div class="is-flex is-align-items-center is-flex-wrap-wrap">
                                                <input 
                                                    class="input is-small has-text-weight-bold" 
                                                    type="text" 
                                                    v-model="quest.titolo" 
                                                    placeholder="Titolo del questionario"
                                                    style="max-width: 320px;"
                                                    @click.stop
                                                />
                                                <span v-if="quest.stato === 'locale'" class="tag is-info is-light ml-2">Locale (Non salvato)</span>
                                                <span v-else-if="quest.stato === 'bozza'" class="tag is-warning is-light ml-2">Bozza</span>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="is-flex is-align-items-center is-flex-wrap-wrap">
                                                <strong class="is-size-5">{{ quest.titolo }}</strong>
                                                <span v-if="quest.stato === 'inviato'" class="tag is-link is-light ml-2">Inviato al Cliente</span>
                                                <span v-else-if="quest.stato === 'compilato'" class="tag is-success is-light ml-2">Compilato</span>
                                            </div>
                                        </template>
                                        
                                        <div class="is-size-7 has-text-grey mt-1">
                                            <span v-if="quest.dataInvio">Inviato il: {{ formattaData(quest.dataInvio) }}</span>
                                            <span v-if="quest.dataCompilazione" class="ml-3">Compilato il: {{ formattaData(quest.dataCompilazione) }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="buttons m-0" @click.stop>
                                    <!-- Bottoni Fase 1: Locale -->
                                    <template v-if="quest.stato === 'locale'">
                                        <button class="button is-small is-success" @click="salvaQuestionario(idQuest, quest, 'bozza')">Salva in bozza</button>
                                        <button class="button is-small is-success is-outlined" @click="salvaQuestionario(idQuest, quest, 'inviato')" :disabled="!haCampiOFile(quest)">Salva e invia</button>
                                        <button class="button is-small is-info is-outlined" @click="incollaStrutturaQuestionario(idQuest)" :disabled="!copiaTrasporto?.strutturaQuestionario">Incolla</button>
                                        <button class="button is-small is-danger is-light" @click="annullaModificheQuestionario(idQuest)">Annulla</button>
                                        <button class="button is-small is-danger is-outlined ml-2" @click="richiediEliminazioneQuestionario(idQuest)">Elimina</button>
                                    </template>
                                    <!-- Bottoni Fase 2: Bozza -->
                                    <template v-else-if="quest.stato === 'bozza'">
                                        <button class="button is-small is-success" @click="salvaQuestionario(idQuest, quest, 'bozza')">Salva in bozza</button>
                                        <button class="button is-small is-success is-outlined" @click="salvaQuestionario(idQuest, quest, 'inviato')" :disabled="!haCampiOFile(quest)">Salva e Invia</button>
                                        <button class="button is-small is-info is-outlined" @click="copiaStrutturaQuestionario(quest)">Copia</button>
                                        <button class="button is-small is-danger is-light" @click="annullaModificheQuestionario(idQuest)">Annulla</button>
                                        <button class="button is-small is-danger is-outlined ml-2" @click="richiediEliminazioneQuestionario(idQuest)">Elimina</button>
                                    </template>
                                    <!-- Bottoni Fase 3: Inviato -->
                                    <template v-else-if="quest.stato === 'inviato'">
                                        <button class="button is-small is-warning is-outlined" @click="salvaQuestionario(idQuest, quest, 'bozza')">Blocca</button>
                                        <button class="button is-small is-info is-outlined" @click="copiaStrutturaQuestionario(quest)">Copia</button>
                                        <button class="button is-small is-warning is-light ml-2" @click="rilanciaQuestionario(idQuest)">Rilancia</button>
                                        <button class="button is-small is-danger is-outlined ml-2" @click="richiediEliminazioneQuestionario(idQuest)">Elimina</button>
                                    </template>
                                    <!-- Bottoni Fase 4: Compilato -->
                                    <template v-else-if="quest.stato === 'compilato'">
                                        <button class="button is-small is-info is-outlined" @click="copiaStrutturaQuestionario(quest)">Copia</button>
                                        <button class="button is-small is-warning is-outlined ml-2" @click="rilanciaQuestionario(idQuest)">Rilancia</button>
                                        <button v-if="permettiElimina" class="button is-small is-danger is-outlined ml-2" @click="richiediEliminazioneQuestionario(idQuest)">Elimina</button>
                                    </template>
                                </div>
                            </div>

                            <!-- Contenuto del questionario (visibile solo se aperto) -->
                            <div v-if="questionarioApertoId === idQuest" class="mt-3">
                                <!-- Render Sezioni -->
                                <div v-for="(sez, sIndex) in (quest.sezioni || [])" :key="sIndex" class="box mb-3 p-3 has-background-white-ter" style="position: relative;" v-show="deveMostrareSezione(quest, sIndex)">
                                    <div class="is-flex is-align-items-center is-justify-content-space-between mb-2">
                                        <h5 class="title is-6 has-text-info m-0">Sezione {{sIndex + 1}}: {{ sez.titolo || '(Nessun titolo visualizzato al cliente)' }}</h5>
                                        <div class="buttons is-right m-0" v-if="quest.stato === 'locale' || quest.stato === 'bozza'">
                                            <button class="button is-small is-light" @click="spostaSezione(idQuest, sIndex, -1)" :disabled="sIndex === 0">
                                                <span class="icon is-small"><i class="fas fa-arrow-up"></i></span>
                                            </button>
                                            <button class="button is-small is-light ml-1" @click="spostaSezione(idQuest, sIndex, 1)" :disabled="sIndex === (quest.sezioni || []).length - 1">
                                                <span class="icon is-small"><i class="fas fa-arrow-down"></i></span>
                                            </button>
                                            <button class="button is-small is-danger is-light ml-3" @click="rimuoviSezione(idQuest, sIndex)">Elimina</button>
                                        </div>
                                    </div>
                                    
                                    <EditorSezioneQuestionario v-if="quest.stato === 'locale' || quest.stato === 'bozza'" v-model="quest.sezioni[sIndex]" :campiPrecedenti="getCampiPrecedentiQuestionario(quest, sIndex)" />

                                    <!-- Mostra Risposte/Struttura in Fase 3 e 4 -->
                                    <div class="content is-small mt-3" v-if="(quest.stato === 'inviato' || quest.stato === 'compilato') && sez.campi && Object.keys(sez.campi).length > 0">
                                        <p class="has-text-weight-bold mb-1">
                                            {{ quest.stato === 'compilato' ? 'Risposte inserite dal cliente:' : 'Campi richiesti al cliente:' }}
                                        </p>
                                        <table class="table is-narrow is-striped is-fullwidth">
                                            <tbody>
                                                <tr v-for="{ nomeCampo, info } in getCampiOrdinati(sez.campi)" :key="nomeCampo">
                                                    <td style="width: 30%;"><strong>{{ info.label || formattaNomeCampo(nomeCampo) }}:</strong></td>
                                                    <td>
                                                        <template v-if="info.tipo === 'file'">
                                                            <template v-if="quest.stato === 'compilato'">
                                                                <span v-if="info.url">
                                                                    <a :href="info.url" target="_blank" class="tag is-link is-light">Scarica / Visualizza</a>
                                                                </span>
                                                                <span v-else class="has-text-grey">Non caricato <span v-if="isCampoVeramenteObbligatorio(sez, nomeCampo, info, quest)" class="has-text-danger">(obbligatorio)</span></span>
                                                            </template>
                                                            <template v-else>
                                                                <span class="has-text-grey">In attesa... <span v-if="isCampoVeramenteObbligatorio(sez, nomeCampo, info, quest)" class="has-text-danger">(obbligatorio)</span></span>
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            {{ quest.stato === 'compilato' ? formattaRispostaCampo(info) : '---' }}
                                                        </template>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <!-- Mostra File in Fase 3 e 4 -->
                                    <div class="content is-small mt-2" v-if="(quest.stato === 'inviato' || quest.stato === 'compilato') && sez.file && Object.keys(sez.file).length > 0">
                                        <p class="has-text-weight-bold mb-1">
                                            {{ quest.stato === 'compilato' ? 'Documenti caricati dal cliente:' : 'Documenti richiesti al cliente:' }}
                                        </p>
                                        <div v-for="{ chiaveFile, infoFile } in getFileOrdinati(sez.file)" :key="chiaveFile" class="mb-2">
                                            <span class="mr-2"><strong>{{ infoFile.label || formattaNomeCampo(chiaveFile) }}:</strong></span>
                                            <template v-if="quest.stato === 'compilato'">
                                                <span v-if="infoFile.url">
                                                    <a :href="infoFile.url" target="_blank" class="tag is-link is-light">Scarica / Visualizza</a>
                                                </span>
                                                <span v-else class="has-text-grey">Non caricato <span v-if="infoFile.obbligatorio" class="has-text-danger">(obbligatorio)</span></span>
                                            </template>
                                            <template v-else>
                                                <span class="has-text-grey">In attesa... <span v-if="infoFile.obbligatorio" class="has-text-danger">(obbligatorio)</span></span>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    </div>

                    <!-- SUBTAB 2: DOCUMENTI CONDIVISI -->
                    <div v-if="subTabAreaCliente == 'documenti'">
                        <div v-if="!areaRiservataAttiva" class="notification is-warning is-light mb-3">
                            <p>Nessun link di accesso attivo per questo cantiere. Attiva l'area riservata nel tab <strong>"Accesso"</strong> per condividere documenti.</p>
                        </div>
                        <div v-else class="box has-background-white p-4">
                            <h4 class="title is-6 mb-3">Carica Documento da Condividere col Cliente</h4>
                            <div class="field mb-3">
                                <label class="label is-small">Titolo Documento</label>
                                <div class="control">
                                    <input class="input is-small" type="text" v-model="nuovoDocCondivisoTitolo" placeholder="Es. Progetto Impianto Elettrico">
                                </div>
                            </div>
                            <div class="field mb-3">
                                <div class="file has-name is-small is-fullwidth">
                                    <label class="file-label">
                                        <input class="file-input" type="file" @change="selezionaFileCondiviso">
                                        <span class="file-cta">
                                            <span class="file-icon"><i class="fas fa-upload"></i></span>
                                            <span class="file-label">Scegli file...</span>
                                        </span>
                                        <span class="file-name">
                                            {{ fileCondivisoSelezionato ? fileCondivisoSelezionato.name : 'Nessun file selezionato' }}
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="field">
                                <button class="button is-small is-primary" :class="{'is-loading': caricamentoUploadCondiviso}" @click="caricaDocumentoCondiviso" :disabled="!fileCondivisoSelezionato || !nuovoDocCondivisoTitolo">
                                    Carica e Condividi
                                </button>
                            </div>

                            <hr>

                            <h4 class="title is-6 mb-3">Documenti Condivisi Attivi</h4>
                            <div v-if="!areaRiservataAttiva.documentiCondivisi || Object.keys(areaRiservataAttiva.documentiCondivisi).length === 0" class="notification is-info is-light is-small py-2">
                                Nessun documento condiviso con il cliente.
                            </div>
                            <table v-else class="table is-narrow is-fullwidth is-striped">
                                <thead>
                                    <tr>
                                        <th>Titolo / Nome File</th>
                                        <th>Data Caricamento</th>
                                        <th class="has-text-right">Azioni</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(docInfo, key) in areaRiservataAttiva.documentiCondivisi" :key="key">
                                        <td>
                                            <strong>{{ docInfo.nome }}</strong>
                                            <br>
                                            <a :href="docInfo.url" target="_blank" class="is-size-7 is-link">Apri file</a>
                                        </td>
                                        <td class="is-size-7">{{ formattaDataScadenza(docInfo.dataCaricamento) }}</td>
                                        <td class="has-text-right">
                                            <button class="button is-small is-danger is-light" @click="eliminaDocumentoCondiviso(key)">
                                                Elimina
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- SUBTAB 3: FASI CLIENTE -->
                    <div v-if="subTabAreaCliente == 'fasi'">
                        <div v-if="!areaRiservataAttiva" class="notification is-warning is-light mb-3">
                            <p>Nessun link di accesso attivo per questo cantiere. Attiva l'area riservata nel tab <strong>"Accesso"</strong> per configurare le fasi cliente.</p>
                        </div>
                        <div v-else class="box has-background-white p-4">
                            <div class="is-flex is-justify-content-space-between is-align-items-center mb-3">
                                <h4 class="title is-6 mb-0">Fasi Visibili al Cliente</h4>
                                <button class="button is-small is-primary" @click="aggiungiNuovaFaseCliente">
                                    Aggiungi Fase
                                </button>
                            </div>

                            <div v-if="!areaRiservataAttiva.fasi || Object.keys(areaRiservataAttiva.fasi).length === 0" class="notification is-info is-light is-small py-2">
                                Nessuna fase di lavoro configurata per l'area riservata.
                            </div>
                            
                            <div v-else>
                                <div v-for="(fase, index) in fasiClienteOrdinate" :key="fase.key" class="box p-3 mb-2 has-background-white-ter animate__animated animate__fadeIn">
                                    <div class="columns is-multiline is-mobile is-vcentered">
                                        <div class="column is-6-tablet is-12-mobile">
                                            <div class="field">
                                                <label class="label is-small">Descrizione Fase</label>
                                                <div class="control">
                                                    <input class="input is-small" type="text" v-model="fase.descrizione" @change="salvaFaseCliente(fase.key, fase)">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="column is-3-tablet is-6-mobile">
                                            <div class="field">
                                                <label class="label is-small">Data Inizio</label>
                                                <div class="control">
                                                    <input class="input is-small" type="date" v-model="fase.dataInizio" @change="salvaFaseCliente(fase.key, fase)">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="column is-3-tablet is-6-mobile">
                                            <div class="field">
                                                <label class="label is-small">Tipo Data Inizio</label>
                                                <div class="control">
                                                    <div class="select is-small is-fullwidth">
                                                        <select v-model="fase.statoInizio" @change="salvaFaseCliente(fase.key, fase)">
                                                            <option value="stimata">Stimata</option>
                                                            <option value="pianificata">Pianificata</option>
                                                            <option value="effettiva">Effettiva</option>
                                                            <option value="nascosta">Nascosta</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="column is-6-tablet is-12-mobile">
                                            <div class="columns is-mobile">
                                                <div class="column is-6">
                                                    <div class="field">
                                                        <label class="label is-small">Avanzamento (%)</label>
                                                        <div class="control">
                                                            <input class="input is-small" type="number" min="0" max="100" v-model.number="fase.percentuale" @change="salvaFaseCliente(fase.key, fase)">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="column is-6">
                                                    <div class="field">
                                                        <label class="label is-small">Percentuale Visibile</label>
                                                        <div class="control">
                                                            <div class="select is-small is-fullwidth">
                                                                <select v-model="fase.visibilePercentuale" @change="salvaFaseCliente(fase.key, fase)">
                                                                    <option value="visibile">Visibile</option>
                                                                    <option value="nascosta">Nascosta</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="column is-3-tablet is-6-mobile">
                                            <div class="field">
                                                <label class="label is-small">Data Fine</label>
                                                <div class="control">
                                                    <input class="input is-small" type="date" v-model="fase.dataFine" @change="salvaFaseCliente(fase.key, fase)">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="column is-3-tablet is-6-mobile">
                                            <div class="field">
                                                <label class="label is-small">Tipo Data Fine</label>
                                                <div class="control">
                                                    <div class="select is-small is-fullwidth">
                                                        <select v-model="fase.statoFine" @change="salvaFaseCliente(fase.key, fase)">
                                                            <option value="stimata">Stimata</option>
                                                            <option value="pianificata">Pianificata</option>
                                                            <option value="effettiva">Effettiva</option>
                                                            <option value="nascosta">Nascosta</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="is-flex is-justify-content-space-between is-align-items-center mt-2">
                                        <div>
                                            <button class="button is-small is-light" @click="spostaFaseCliente(fase.key, -1)" :disabled="index === 0">
                                                <span class="icon is-small"><i class="fas fa-arrow-up"></i></span>
                                            </button>
                                            <button class="button is-small is-light ml-1" @click="spostaFaseCliente(fase.key, 1)" :disabled="index === fasiClienteOrdinate.length - 1">
                                                <span class="icon is-small"><i class="fas fa-arrow-down"></i></span>
                                            </button>
                                        </div>
                                        <button class="button is-small is-danger is-light" @click="rimuoviFaseCliente(fase.key)">
                                            Elimina Fase
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>

            <div>&nbsp;</div>
        </div>

        <MessaggioModale @selezionato="bComandoModale"
            :confMessaggioModale=messaggioModale
            v-if="messaggioModale"/>

        <ElencoClientiModale
            :bottoneAggiungiVisibile=false
            :campoRicercaVisibile=true
            @elementoSelezionato="bCambiaClienteDaModale"
            v-if="mostraElencoClientiModale"/>
    </div>
</template>

<script setup>
    import CampoData from "./CampoData.vue";
    import CampoNumero from "./CampoNumero.vue";
    import CampoTendina from "./CampoTendina.vue";
    import MessaggioModale from "./MessaggioModale.vue";
    import ElencoClientiModale from "./ElencoClientiModale.vue";
    import ElencoFasi from './ElencoFasi.vue';
    import FormFase from "./FormFase.vue";
    import ElencoContabili from "./ElencoContabili.vue";
    import FormContabile from "./FormContabile.vue";
    import ElencoDico from "./ElencoDico.vue";
    import FormDico from "./FormDico.vue";
    import ElencoContatti from "./ElencoContatti.vue";
    import ElencoCosti from "./ElencoCosti.vue";
    import FormCosto from "./FormCosto.vue";
    import EditorSezioneQuestionario from "./EditorSezioneQuestionario.vue";
    import { defineProps, defineEmits, ref, nextTick, watch, onMounted, onUnmounted, computed } from "vue";
    import { dbClienti, salvaLavoroInFirestore, eliminaLavoroInFirestore, cambiaClienteALavoroInFirestore, leggiInfoDB, leggiInfoDBRaw, aggiungiInfoDB, aggiungiTagLeadInFirestore } from "./../code/gestioneDB";
    import { generaIdLavoro, generaStringaCliente, apriLinkLuogo, permettiElimina, copiaTrasporto, statoInterfaccia, impostazioniGenerali, clonaOggetto, schermoLargo } from "./../code/utilita";

    import { doc, setDoc, getDoc, updateDoc, Timestamp, collection, query, where, onSnapshot, deleteField, writeBatch } from 'firebase/firestore';
    import { db } from '../code/firebase';
    import { getStorage, ref as storageRef, uploadBytes, getDownloadURL, deleteObject, listAll, getBytes, getBlob, getMetadata } from 'firebase/storage';

    const storageInstance = getStorage();

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        idLavoro: {
            type: Number,
            default: -1
        },
        idCliente: {
            type: Number,
            required: true
        }
    });
    const emit = defineEmits(['elementoSelezionato', 'modificaElementoInCorso']);

    // VARIABILI DEL COMPONENTE
    const nuovoTag = ref('');
    const lavoroSelezionato = ref({});             
    const lavoroDaAggiornare = ref(null);            
    const messaggioModale = ref(null);               
    const mostraElencoClientiModale = ref(false);    
    const idLavoroSelezionato = ref(props.idLavoro || -1);
    const idFaseSelezionata = ref(null);              
    const idContabileSelezionata = ref(null);         
    const idDicoSelezionata = ref(null);              
    const idCostoSelezionato = ref(null);             
    const interfacciaBloccata = ref(false);
    const formAttivo = ref(true);                   
    const testoRicercaCosti = ref('');
    const dataInizioRicercaCosti = ref(null);
    const dataFineRicercaCosti = ref(null);
    function calcolaDataScadenzaDefault() {
        const d = new Date();
        d.setDate(d.getDate() + 30);
        d.setHours(23, 59, 59, 999);
        return Timestamp.fromDate(d);
    }
    const dataDisattivazioneIniziale = ref(calcolaDataScadenzaDefault());
    const caricamentoToken = ref(false);
    // Riferimento reattivo per l'area riservata attualmente aperta ed emessa dal client
    const areaRiservataAttiva = ref(null);
    let unsubscribeAreaCliente = null;

    // Computed property per ordinare i tag alfabeticamente portando "Altro" in fondo
    const tagsGlobaliOrdinati = computed(() => {
        if (!impostazioniGenerali.value || !impostazioniGenerali.value.tagsLeads) return [];
        
        // Creiamo una copia dell'array con lo spread operator [...] per non mutare l'originale
        return [...impostazioniGenerali.value.tagsLeads].sort((a, b) => {
            const tagA = a.toLowerCase();
            const tagB = b.toLowerCase();
            
            // Gestione dell'eccezione per la voce "altro"
            if (tagA === 'altro') return 1;  // Sposta 'a' dopo 'b'
            if (tagB === 'altro') return -1; // Sposta 'b' dopo 'a'
            
            // Ordinamento alfabetico standard per tutti gli altri
            return tagA.localeCompare(tagB);
        });
    });

    // FIX: Watcher di sicurezza per cambi asincroni
    watch(() => props.idLavoro, (nuovoId) => {
        idLavoroSelezionato.value = nuovoId || -1;
        setupFormLavoro();
        disattivaListenerAreaCliente();
        attivaListenerAreaCliente();
    });

    // SETUP DEL COMPONENTE
    setupFormLavoro();

    // FUNZIONI DEL COMPONENTE
    function setupFormLavoro() {
        dataDisattivazioneIniziale.value = calcolaDataScadenzaDefault();
        if (!statoInterfaccia.value.formLavoroTab || (props.idLavoro==-1) ) 
            statoInterfaccia.value.formLavoroTab = 1;
        
        const id = idLavoroSelezionato.value;

        // FIX: Scheletro di Base 
        const scheletroBase = {
            tipo: null,
            oggetto: null,
            tags: [], // Aggiunto per i tag
            contatti: {}
        };

        if ( id == -1 ) {
            lavoroSelezionato.value = { ...scheletroBase };
            aggiungiInfoDB(lavoroSelezionato.value, {
                id: -1,
                idCliente: props.idCliente,
                stringaCliente: generaStringaCliente(props.idCliente)
            });
        } else {
            // FIX: Estrazione Sicura usando props.idCliente
            const clienteOriginale = dbClienti.value[props.idCliente];
            const lavoroOriginale = (clienteOriginale && clienteOriginale.lavori) ? clienteOriginale.lavori[id] : null;

            if (lavoroOriginale) {
                lavoroSelezionato.value = { ...scheletroBase, ...clonaOggetto(lavoroOriginale) };
                
                // --- FIX TAGS ---
                // Mantiene l'array puro dopo il clonaOggetto
                if (lavoroOriginale.tags && Array.isArray(lavoroOriginale.tags)) {
                    lavoroSelezionato.value.tags = [...lavoroOriginale.tags];
                } else if (!Array.isArray(lavoroSelezionato.value.tags)) {
                    lavoroSelezionato.value.tags = [];
                }
                // ----------------

                // FIX: Ricostruisce i metadati
                const infoRaw = leggiInfoDBRaw(lavoroOriginale) || { id: id, idCliente: props.idCliente };
                aggiungiInfoDB(lavoroSelezionato.value, infoRaw);
            } else {
                lavoroSelezionato.value = { ...scheletroBase };
                aggiungiInfoDB(lavoroSelezionato.value, { id: id, idCliente: props.idCliente });
            }
        }
        lavoroDaAggiornare.value = null;
    }

    function lavoroModifica(valore, etichetta) {
        if (lavoroDaAggiornare.value == null) {
            lavoroDaAggiornare.value = {};
            emit('modificaElementoInCorso', true);
        }
        lavoroDaAggiornare.value[etichetta] = valore;
        lavoroSelezionato.value[etichetta] = valore;
    }

    function bAnnulla() {
        if (lavoroDaAggiornare.value != null) {
            messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:null,
                testoDanger:{testo:'Cancella le modifiche', comando:'cancella'},
                messaggio:"Proseguendo perderai le modifiche fatte"
            };
        }
    }

    function bSalva() {
        if (!lavoroSelezionato.value.tags || lavoroSelezionato.value.tags.length === 0) {
            messaggioModale.value = {
                testoLight:{testo:'Ok', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"Prima di salvare inserisci almeno un Tag."
            };
            return; // Blocca immediatamente l'esecuzione e il salvataggio su Firestore
        }

        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:{testo:'Salva', comando:'salva'},
            testoDanger:null,
            messaggio:"Vuoi salvare le modifiche al Lavoro?"
        };
    }

    function bElimina() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:null,
            testoDanger:{testo:'Elimina', comando:'elimina'},
            messaggio:"Vuoi eliminare il Lavoro?"
        };
    }

    async function bComandoModale(comando) {
        // FIX: Sicurezza extra per evitare undefined se l'oggetto è orfano
        const tpIdCliente = leggiInfoDBRaw(lavoroSelezionato.value).idCliente || props.idCliente; 
        
        // FIX: Raggruppiamo i case in blocchi isolati ({ }) per placare ESLint
        switch (comando) {
            case 'annulla': {
                messaggioModale.value = null;
                break;
            }
            default: {
                if (comando.startsWith('eliminaQuestionario_')) {
                    const idQuest = comando.replace('eliminaQuestionario_', '');
                    rimuoviQuestionario(idQuest, true);
                    messaggioModale.value = null;
                    return;
                }
                break;
            }
            case 'cancella': {
                emit('modificaElementoInCorso', false);
                messaggioModale.value = null;
                setupFormLavoro();
                resetForm();
                break;
            }
            case 'salva': {
                if (idLavoroSelezionato.value == -1) {
                    idLavoroSelezionato.value = generaIdLavoro();
                }
                aggiungiInfoDB(lavoroDaAggiornare.value, {
                    id: idLavoroSelezionato.value,
                    idCliente: tpIdCliente
                });
                await salvaLavoroInFirestore(lavoroDaAggiornare.value);
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'lavoro',
                    idCliente: tpIdCliente,
                    idLavoro: idLavoroSelezionato.value
                });
                break;
            }
            case 'elimina': {
                eliminaLavoroInFirestore(tpIdCliente, idLavoroSelezionato.value);
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'lavori'
                });
                break;
            }
            case 'incollaContatti': {
                lavoroDaAggiornare.value = {};
                aggiungiInfoDB(lavoroDaAggiornare.value, {
                    id: props.idLavoro,
                    idCliente: props.idCliente
                });
                lavoroDaAggiornare.value.contatti = copiaTrasporto.value.contatti;
                await salvaLavoroInFirestore(lavoroDaAggiornare.value);
                lavoroDaAggiornare.value = null;
                messaggioModale.value = null;
                break;
            }
            case 'incollaPosizione': {
                if (copiaTrasporto.value.posizione.indirizzo) {
                    lavoroModifica(copiaTrasporto.value.posizione.indirizzo, 'indirizzo');
                }
                if (copiaTrasporto.value.posizione.luogo) {
                    lavoroModifica(copiaTrasporto.value.posizione.luogo, 'luogo');
                }
                messaggioModale.value = null;
                break;
            }
            case 'copiaIndirizzoAnagrafica': {
                // FIX: Scudo condizionale anti-undefined
                let stringaIndirizzo = '';
                const indCliente = dbClienti.value[props.idCliente]?.indirizzo;
                
                if (indCliente) {
                    const parti = [];
                    if (indCliente.via) parti.push(indCliente.via);
                    if (indCliente.civico) parti.push(indCliente.civico);
                    if (indCliente.citta) parti.push(indCliente.citta);
                    if (indCliente.provincia) parti.push(indCliente.provincia);
                    
                    stringaIndirizzo = parti.join(', ');
                }
                lavoroModifica(stringaIndirizzo, 'indirizzo');
                messaggioModale.value = null;
                break;
            }
        }
    }

    function bCambiaCliente() {
        if (!interfacciaBloccata.value && !lavoroDaAggiornare.value) {
            mostraElencoClientiModale.value = true;
        }
    }

    async function bCambiaClienteDaModale(tempElemento) {
        // FIX: Sicurezza extra per evitare undefined 
        const currentIdCliente = leggiInfoDBRaw(lavoroSelezionato.value).idCliente || props.idCliente;

        if (tempElemento.idCliente!=null && currentIdCliente!=tempElemento.idCliente){
            formAttivo.value = false;           
            await cambiaClienteALavoroInFirestore(currentIdCliente, idLavoroSelezionato.value, tempElemento.idCliente);
            emit('modificaElementoInCorso', false);
            emit('elementoSelezionato', {
                tipo: 'lavoro',
                idCliente: tempElemento.idCliente,
                idLavoro: idLavoroSelezionato.value
            });
        }
        mostraElencoClientiModale.value = false;
    }

    function bSelezionaTAb(index) {
        if (interfacciaBloccata.value) {
            messaggioModale.value = {
            testoLight:{testo:'Ok', comando:'annulla'},
            testoPrimary:null,
            testoDanger:null,
            messaggio:"Per proseguire devi salvare o annullare le modifiche" };
        } else {
            if ( index>2 && ( props.idLavoro==-1 || lavoroDaAggiornare.value ) ) {
                messaggioModale.value = {
                testoLight:{testo:'Ok', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"Per proseguire devi salvare le modifiche al lavoro" };
            } else {
                idFaseSelezionata.value = null;
                idContabileSelezionata.value = null;
                idDicoSelezionata.value = null;
                idCostoSelezionato.value = null;
                statoInterfaccia.value.formLavoroTab = index;
            }
        }
    }

    function bBloccaInterfaccia(stato) {
        interfacciaBloccata.value = stato;
        emit('modificaElementoInCorso', stato);
    }

    async function gestisciSelezioneElemento(elSelezionato) {
        if (lavoroDaAggiornare.value != null || interfacciaBloccata.value == true) {
            messaggioModale.value = {
                testoLight:{testo:'Ok', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"Per proseguire devi chiudere le modifiche"
            };
        } else {
            switch (elSelezionato.tipo) {
                case 'cliente':
                    emit('elementoSelezionato', elSelezionato);
                    break;
                case 'fase':
                    if (idFaseSelezionata.value != null) {
                        idFaseSelezionata.value = null;
                        await nextTick();
                    }
                    idFaseSelezionata.value = elSelezionato.idFase;
                    break;
                case 'fasi':
                    idFaseSelezionata.value = null;
                    break;
                case 'dico':
                    if (idDicoSelezionata.value != null) {
                        idDicoSelezionata.value = null;
                        await nextTick();
                    }
                    idDicoSelezionata.value = elSelezionato.idDico;
                    break;
                case 'dicos':
                    idDicoSelezionata.value = null;
                    break;
                case 'contabile':
                    if (idContabileSelezionata.value != null) {
                        idContabileSelezionata.value = null;
                        await nextTick();
                    }
                    idContabileSelezionata.value = elSelezionato.idDico;
                    break;
                case 'contabili':
                    idContabileSelezionata.value = null;
                    break;
                case 'costo':
                    if (idCostoSelezionato.value != null) {
                        idCostoSelezionato.value = null;
                        await nextTick();
                    }
                    idCostoSelezionato.value = elSelezionato.idCosto;
                    break;
                case 'costi':
                    idCostoSelezionato.value = null;
                    break;
                case 'contatto':
                    emit('elementoSelezionato', elSelezionato);
            }
        }
    }

    async function cambiaStatoInterfaccia(tempStato) {
        formAttivo.value = false;
        if (tempStato.testoRicercaCosti) {
            testoRicercaCosti.value = tempStato.testoRicercaCosti;
        }
        if (tempStato.dataInizioRicercaCosti) {
            dataInizioRicercaCosti.value = tempStato.dataInizioRicercaCosti;
        }
        if (tempStato.dataFineRicercaCosti) {
            dataFineRicercaCosti.value = tempStato.dataFineRicercaCosti;
        }
        await nextTick();
        formAttivo.value = true;
    }

    function bCopiaContatti() {
        // FIX: Scudo condizionale come in FormLead
        const lavoroCorrente = (dbClienti.value[props.idCliente] && dbClienti.value[props.idCliente].lavori) 
                                ? dbClienti.value[props.idCliente].lavori[props.idLavoro] 
                                : null;

        if ( lavoroCorrente && 'contatti' in lavoroCorrente ) {
            copiaTrasporto.value.contatti = lavoroCorrente.contatti;
            if ( Object.keys(copiaTrasporto.value.contatti).length === 0 ) {
                delete copiaTrasporto.value.contatti;
            }
        }
    }

    function bIncollaContatti() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:{testo:'Incolla', comando:'incollaContatti'},
            testoDanger:null,
            messaggio:"Proseguendo verranno incollati " + Object.keys(copiaTrasporto.value.contatti).length + " contatti" };
    }
    
    function bCopiaPosizione() {
        copiaTrasporto.value.posizione = {indirizzo:'', luogo:''};

        // FIX: Scudo condizionale come in FormLead
        const lavoroCorrente = (dbClienti.value[props.idCliente] && dbClienti.value[props.idCliente].lavori) 
                                ? dbClienti.value[props.idCliente].lavori[props.idLavoro] 
                                : null;

        if ( lavoroCorrente && 'indirizzo' in lavoroCorrente ) {
            copiaTrasporto.value.posizione.indirizzo = lavoroCorrente.indirizzo;
        } else {
            delete copiaTrasporto.value.posizione.indirizzo;
        }
        if ( lavoroCorrente && 'luogo' in lavoroCorrente ) {
            copiaTrasporto.value.posizione.luogo = lavoroCorrente.luogo;
        } else {
            delete copiaTrasporto.value.posizione.luogo;
        }
        messaggioModale.value = {
            testoLight:{testo:'Ok', comando:'annulla'},
            testoPrimary:null,
            testoDanger:null,
            messaggio:"La posizione è stata copiata negli appunti"
        };
    }

    function bIncollaPosizione() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:{testo:'Incolla', comando:'incollaPosizione'},
            testoDanger:null,
            messaggio:"Proseguendo verrà sovrascritto l'indirizzo e la posizione" };
    }

    function bCopiaIndirizzoAnagrafica() {
        if (dbClienti.value[props.idCliente]?.indirizzo) {
            messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:{testo:'Copia', comando:'copiaIndirizzoAnagrafica'},
                testoDanger:null,
                messaggio:"Proseguendo verrà sovrascritto l'indirizzo" };
            
        } else {
            messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"Non è presente un indirizzo in anagrafica" };
        }
    }

    async function resetForm() {
        formAttivo.value = false;
        await nextTick();
        formAttivo.value = true;
    }

    async function bAggiungiTag() {
        const tag = nuovoTag.value.trim();
        if (!tag) return;

        // Inizializza l'array se proveniamo da vecchi documenti senza tags
        if (!lavoroSelezionato.value.tags) {
            lavoroSelezionato.value.tags = [];
        }

        // Aggiunge solo se non è un duplicato nel lavoro corrente
        if (!lavoroSelezionato.value.tags.includes(tag)) {
            // Creiamo un nuovo array per garantire la reattività di Vue
            const nuoviTags = [...lavoroSelezionato.value.tags, tag];
            lavoroModifica(nuoviTags, 'tags');
            
            // Verifica e aggiorna il vocabolario globale se è un tag inedito
            const tagsGlobali = impostazioniGenerali.value.tagsLeads || [];
            if (!tagsGlobali.includes(tag)) {
                await aggiungiTagLeadInFirestore(tag);
            }
        }
        // Resetta l'input
        nuovoTag.value = '';
    }

    function bRimuoviTag(index) {
        const nuoviTags = [...lavoroSelezionato.value.tags];
        nuoviTags.splice(index, 1);
        lavoroModifica(nuoviTags, 'tags');
    }

    // Genera una stringa alfanumerica casuale per il token
    function generaRandomToken() {
        const caratteri = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let risultato = '';
        for (let i = 0; i < 28; i++) {
            risultato += caratteri.charAt(Math.floor(Math.random() * caratteri.length));
        }
        return risultato;
    }

    function generalinkEsterno(token) {
        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
            return `http://localhost:8081/accesso/${token}`;
        }
        return `https://lmc-clienti.web.app/accesso/${token}`;
    }

    function copiaLinkClipboard(token) {
        navigator.clipboard.writeText(generalinkEsterno(token));
        alert("Link copiato negli appunti!");
    }



    async function creaNuovaAreaRiservata(questionariEreditati = null, documentiEreditati = null, fasiEreditate = null) {
        if (!props.idLavoro || !props.idCliente) return;
        
        caricamentoToken.value = true;
        const nuovoToken = generaRandomToken();
        
        let scadenzaDate;
        if (dataDisattivazioneIniziale.value) {
            if (dataDisattivazioneIniziale.value.toDate && typeof dataDisattivazioneIniziale.value.toDate === 'function') {
                scadenzaDate = dataDisattivazioneIniziale.value.toDate();
            } else if (dataDisattivazioneIniziale.value.seconds) {
                scadenzaDate = new Date(dataDisattivazioneIniziale.value.seconds * 1000);
            } else {
                scadenzaDate = new Date(dataDisattivazioneIniziale.value);
            }
        }
        if (!scadenzaDate || isNaN(scadenzaDate.getTime())) {
            scadenzaDate = new Date();
            scadenzaDate.setDate(scadenzaDate.getDate() + 30);
        }
        scadenzaDate.setHours(23, 59, 59, 999);
        const scadenza = Timestamp.fromDate(scadenzaDate);

        const questionari = questionariEreditati || {};

        try {
            // Fasi specifiche dell'area riservata (inizialmente vuote se non esplicitamente ereditate)
            const fasiLavoro = fasiEreditate || {};
            const documentiCondivisi = documentiEreditati || {};

            // Scrittura 1: Crea il token live sulla collezione esterna dei clienti
            await setDoc(doc(db, 'aree_riservate_clienti', nuovoToken), {
                token: nuovoToken,
                idCliente: Number(props.idCliente),
                idLavoro: Number(props.idLavoro),
                statoLavoro: "attivo",
                dataScadenza: scadenza,
                questionari: questionari,
                fasi: fasiLavoro,
                documentiCondivisi: documentiCondivisi,
                documentiRichiesti: {},
                documentiFineLavoro: {}
            });

            // Scrittura 2: Aggiorna l'oggetto cantiere locale per mostrare subito il link a schermo
            let cantiereAggiornato = {
                id: props.idLavoro,
                idCliente: props.idCliente,
                _info: {
                    areaRiservataAttiva: {
                        token: nuovoToken,
                        dataScadenza: scadenza,
                        statoLavoro: 'attivo'
                    }
                }
            };
            
            await salvaLavoroInFirestore(cantiereAggiornato);
            
            await updateDoc(doc(db, 'clienti', String(props.idCliente)), {
                modified: Timestamp.now()
            });
            
            if (lavoroSelezionato.value._info) {
                lavoroSelezionato.value._info.areaRiservataAttiva = cantiereAggiornato._info.areaRiservataAttiva;
            }
            
            alert('Nuova area riservata creata con successo!');
        } catch (e) {
            console.error("Errore generazione area riservata:", e);
            alert("Errore durante la creazione dell'area riservata.");
        } finally {
            caricamentoToken.value = false;
        }
    }

    async function toggleStatoAreaRiservata(token, nuovoStato) {
        if (!token) return;
        
        caricamentoToken.value = true;
        try {
            const docRef = doc(db, 'aree_riservate_clienti', token);
            await updateDoc(docRef, {
                statoLavoro: nuovoStato
            });

            // Aggiorna lo stato nel cantiere locale su Firestore
            let cantiereAggiornato = {
                id: props.idLavoro,
                idCliente: props.idCliente,
                _info: {
                    areaRiservataAttiva: {
                        ...(lavoroSelezionato.value?._info?.areaRiservataAttiva || {}),
                        statoLavoro: nuovoStato
                    }
                }
            };
            await salvaLavoroInFirestore(cantiereAggiornato);
            
            await updateDoc(doc(db, 'clienti', String(props.idCliente)), {
                modified: Timestamp.now()
            });
            
            if (lavoroSelezionato.value?._info?.areaRiservataAttiva) {
                lavoroSelezionato.value._info.areaRiservataAttiva.statoLavoro = nuovoStato;
            }
            alert(`Area riservata ${nuovoStato === 'attivo' ? 'riattivata' : 'disattivata'} con successo!`);
        } catch (e) {
            console.error(`Errore durante il cambio di stato area riservata (${nuovoStato}):`, e);
            alert("Errore durante l'operazione sull'area riservata.");
        } finally {
            caricamentoToken.value = false;
        }
    }

    async function eliminaFileDaStorage(pathOrUrl) {
        if (!pathOrUrl) return;
        try {
            const fileRef = storageRef(storageInstance, pathOrUrl);
            await deleteObject(fileRef);
        } catch (err) {
            console.warn("File storage non trovato o già eliminato:", pathOrUrl, err);
        }
    }

    async function eliminaCartellaStorage(cartellaPath) {
        if (!cartellaPath) return;
        try {
            const folderRef = storageRef(storageInstance, cartellaPath);
            const res = await listAll(folderRef);
            const eliminaFiles = res.items.map(itemRef => deleteObject(itemRef).catch(e => console.warn(e)));
            const eliminaSottocartelle = res.prefixes.map(subfolderRef => eliminaCartellaStorage(subfolderRef.fullPath));
            await Promise.all([...eliminaFiles, ...eliminaSottocartelle]);
        } catch (err) {
            console.warn("Errore durante l'eliminazione della cartella storage:", cartellaPath, err);
        }
    }

    function estraiTokenDaUrlOPath(urlOrPath) {
        if (!urlOrPath || typeof urlOrPath !== 'string') return null;
        const match = urlOrPath.match(/aree_riservate_clienti(?:%2F|\/)([^%2F/?&]+)/);
        return (match && match[1]) ? decodeURIComponent(match[1]) : null;
    }

    async function scaricaBlobDaStorage(itemRef) {
        try {
            return await getBlob(itemRef);
        } catch (e1) {
            console.warn("getBlob fallito, tento via downloadURL/fetch...", e1);
        }

        try {
            const bytes = await getBytes(itemRef);
            return new Blob([bytes]);
        } catch (e2) {
            console.warn("getBytes fallito, tento via fetch...", e2);
        }

        try {
            const downloadUrl = await getDownloadURL(itemRef);
            const resp = await fetch(downloadUrl);
            if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
            return await resp.blob();
        } catch (e3) {
            console.warn("fetch downloadURL fallito, tento via XMLHttpRequest...", e3);
        }

        return new Promise((resolve, reject) => {
            getDownloadURL(itemRef).then((downloadUrl) => {
                const xhr = new XMLHttpRequest();
                xhr.responseType = 'blob';
                xhr.onload = () => {
                    if (xhr.status === 200 || xhr.status === 0) {
                        resolve(xhr.response);
                    } else {
                        reject(new Error(`XHR status ${xhr.status}`));
                    }
                };
                xhr.onerror = () => reject(new Error('XHR Network Error'));
                xhr.open('GET', downloadUrl);
                xhr.send();
            }).catch(reject);
        });
    }

    async function spostaCartellaStorage(vecchiaCartella, nuovaCartella) {
        const oldFolderRef = storageRef(storageInstance, vecchiaCartella);
        const mappaUrls = {};

        try {
            const res = await listAll(oldFolderRef);
            
            for (const itemRef of res.items) {
                try {
                    const relPath = itemRef.fullPath.substring(vecchiaCartella.length);
                    const targetPath = nuovaCartella + relPath;
                    const targetRef = storageRef(storageInstance, targetPath);

                    const blob = await scaricaBlobDaStorage(itemRef);
                    const metadata = await getMetadata(itemRef).catch(() => ({}));

                    await uploadBytes(targetRef, blob, metadata.contentType ? { contentType: metadata.contentType } : undefined);
                    const newDownloadUrl = await getDownloadURL(targetRef);
                    const oldDownloadUrl = await getDownloadURL(itemRef).catch(() => null);

                    if (oldDownloadUrl) {
                        mappaUrls[oldDownloadUrl] = newDownloadUrl;
                    }
                    mappaUrls[itemRef.fullPath] = { targetPath, newDownloadUrl };
                    mappaUrls[relPath] = { targetPath, newDownloadUrl };

                    await deleteObject(itemRef).catch(e => console.warn(e));
                } catch (errFile) {
                    console.warn("Errore spostamento file storage:", itemRef.fullPath, errFile);
                }
            }

            for (const subfolderRef of res.prefixes) {
                const relSub = subfolderRef.fullPath.substring(vecchiaCartella.length);
                const subMap = await spostaCartellaStorage(subfolderRef.fullPath, nuovaCartella + relSub);
                Object.assign(mappaUrls, subMap);
            }
        } catch (errFolder) {
            console.warn("Errore scansione cartella storage per spostamento:", vecchiaCartella, errFolder);
        }

        return mappaUrls;
    }

    async function eliminaAreaRiservata(token) {
        if (!token) return;
        
        const conferma = confirm("ATTENZIONE: Stai per eliminare definitivamente l'area riservata. Tutte le risposte dei questionari, i file caricati dal cliente e i dati compilati andranno persi per sempre. Procedere?");
        if (!conferma) return;

        caricamentoToken.value = true;
        try {
            // 1. Elimina da Firebase Storage tutti i documenti e la relativa cartella
            await eliminaCartellaStorage(`aree_riservate_clienti/${token}`);

            const batch = writeBatch(db);
            
            // 2. Elimina dalla collezione esterna il documento sandbox
            const docRef = doc(db, 'aree_riservate_clienti', token);
            batch.delete(docRef);

            // 3. Rimuove il riferimento dal documento cliente
            const clienteRef = doc(db, 'clienti', String(props.idCliente));
            const percorsoCampoAttivo = `lavori.${props.idLavoro}._info.areaRiservataAttiva`;
            
            batch.update(clienteRef, {
                [percorsoCampoAttivo]: deleteField(),
                modified: Timestamp.now()
            });

            await batch.commit();

            // 4. Aggiorna interfaccia RAM
            if (lavoroSelezionato.value?._info) {
                lavoroSelezionato.value._info.areaRiservataAttiva = null;
            }
            
            alert("Area riservata eliminata definitivamente.");
        } catch (e) {
            console.error("Errore eliminazione area riservata:", e);
            alert("Errore durante l'eliminazione dell'area riservata.");
        } finally {
            caricamentoToken.value = false;
        }
    }

    async function rigeneraAreaRiservata(tokenVecchio) {
        if (!tokenVecchio) return;
        
        const conferma = confirm("Il codice attuale smetterà di funzionare e ne verrà generato uno nuovo. I dati già compilati dal cliente verranno clonati e non andranno persi. Vuoi procedere?");
        if (!conferma) return;
        
        caricamentoToken.value = true;
        
        try {
            // Scarica lo snapshot aggiornato del Sandbox
            const vecchioTokenRef = doc(db, 'aree_riservate_clienti', tokenVecchio);
            const docSnap = await getDoc(vecchioTokenRef);
            
            if (!docSnap.exists()) {
                alert("Il documento originale non esiste più.");
                return;
            }
            
            const vecchiaArea = docSnap.data();

            const questionari = vecchiaArea.questionari || {};
            const documentiCondivisi = vecchiaArea.documentiCondivisi || {};
            const fasi = vecchiaArea.fasi || {};

            const nuovoToken = generaRandomToken();
            
            // Normalizza scadenza a Timestamp valido
            let scadenza = Timestamp.now();
            const rawScadenza = areaRiservataAttiva.value?.dataScadenza || vecchiaArea.dataScadenza;
            if (rawScadenza) {
                if (typeof rawScadenza.toDate === 'function') {
                    scadenza = Timestamp.fromDate(rawScadenza.toDate());
                } else if (rawScadenza.seconds !== undefined) {
                    scadenza = new Timestamp(rawScadenza.seconds, rawScadenza.nanoseconds || 0);
                } else if (rawScadenza._seconds !== undefined) {
                    scadenza = new Timestamp(rawScadenza._seconds, rawScadenza._nanoseconds || 0);
                } else if (rawScadenza instanceof Date) {
                    scadenza = Timestamp.fromDate(rawScadenza);
                }
            }

            // 1. Raccogli tutti i vecchi token referenziati nei documenti per spostare anche eventuali cartelle rimaste disallineate
            const tokensDaSpostare = new Set();
            if (tokenVecchio) tokensDaSpostare.add(tokenVecchio);

            for (const dKey in documentiCondivisi) {
                const t = estraiTokenDaUrlOPath(documentiCondivisi[dKey].storagePath || documentiCondivisi[dKey].url);
                if (t) tokensDaSpostare.add(t);
            }
            for (const qKey in questionari) {
                const q = questionari[qKey];
                if (q.sezioni) {
                    for (const sez of q.sezioni) {
                        if (sez.campi) {
                            for (const cKey in sez.campi) {
                                const c = sez.campi[cKey];
                                const t = estraiTokenDaUrlOPath(c.storagePath || c.url);
                                if (t) tokensDaSpostare.add(t);
                            }
                        }
                        if (sez.file) {
                            for (const fKey in sez.file) {
                                const f = sez.file[fKey];
                                const t = estraiTokenDaUrlOPath(f.storagePath || f.url);
                                if (t) tokensDaSpostare.add(t);
                            }
                        }
                    }
                }
            }

            // Sposta tutti i file dalle vecchie cartelle verso la cartella del nuovoToken
            const mappaUrls = {};
            for (const tOld of tokensDaSpostare) {
                if (tOld !== nuovoToken) {
                    const subMappa = await spostaCartellaStorage(`aree_riservate_clienti/${tOld}`, `aree_riservate_clienti/${nuovoToken}`);
                    Object.assign(mappaUrls, subMappa);
                }
            }

            // 2. Aggiorna i percorsi/URL in questionari
            for (const qKey in questionari) {
                const quest = questionari[qKey];
                if (quest.sezioni) {
                    for (const sez of quest.sezioni) {
                        if (sez.campi) {
                            for (const cKey in sez.campi) {
                                const campo = sez.campi[cKey];
                                if (campo.url) {
                                    if (mappaUrls[campo.url]) {
                                        campo.url = typeof mappaUrls[campo.url] === 'string' ? mappaUrls[campo.url] : mappaUrls[campo.url].newDownloadUrl;
                                    } else {
                                        for (const relPath in mappaUrls) {
                                            if (relPath.startsWith('/') && campo.url.includes(encodeURIComponent(relPath.substring(1)))) {
                                                campo.url = mappaUrls[relPath].newDownloadUrl;
                                                break;
                                            }
                                        }
                                    }
                                    if (typeof campo.txt === 'string' && (campo.txt.startsWith('http') || campo.tipo === 'file')) {
                                        campo.txt = campo.url;
                                    }
                                }
                                if (campo.storagePath) {
                                    if (mappaUrls[campo.storagePath]) {
                                        campo.storagePath = typeof mappaUrls[campo.storagePath] === 'string' ? mappaUrls[campo.storagePath] : mappaUrls[campo.storagePath].targetPath;
                                    } else {
                                        campo.storagePath = campo.storagePath.replace(/aree_riservate_clienti\/[^/]+/, `aree_riservate_clienti/${nuovoToken}`);
                                    }
                                }
                            }
                        }
                        if (sez.file) {
                            for (const fKey in sez.file) {
                                const f = sez.file[fKey];
                                if (f.url) {
                                    if (mappaUrls[f.url]) {
                                        f.url = typeof mappaUrls[f.url] === 'string' ? mappaUrls[f.url] : mappaUrls[f.url].newDownloadUrl;
                                    } else {
                                        for (const relPath in mappaUrls) {
                                            if (relPath.startsWith('/') && f.url.includes(encodeURIComponent(relPath.substring(1)))) {
                                                f.url = mappaUrls[relPath].newDownloadUrl;
                                                break;
                                            }
                                        }
                                    }
                                }
                                if (f.storagePath) {
                                    if (mappaUrls[f.storagePath]) {
                                        f.storagePath = typeof mappaUrls[f.storagePath] === 'string' ? mappaUrls[f.storagePath] : mappaUrls[f.storagePath].targetPath;
                                    } else {
                                        f.storagePath = f.storagePath.replace(/aree_riservate_clienti\/[^/]+/, `aree_riservate_clienti/${nuovoToken}`);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // 3. Aggiorna i percorsi/URL in documentiCondivisi
            for (const dKey in documentiCondivisi) {
                const docInfo = documentiCondivisi[dKey];
                if (docInfo.url) {
                    if (mappaUrls[docInfo.url]) {
                        docInfo.url = typeof mappaUrls[docInfo.url] === 'string' ? mappaUrls[docInfo.url] : mappaUrls[docInfo.url].newDownloadUrl;
                    } else {
                        for (const relPath in mappaUrls) {
                            if (relPath.startsWith('/') && docInfo.url.includes(encodeURIComponent(relPath.substring(1)))) {
                                docInfo.url = mappaUrls[relPath].newDownloadUrl;
                                break;
                            }
                        }
                    }
                }
                if (docInfo.storagePath) {
                    if (mappaUrls[docInfo.storagePath]) {
                        docInfo.storagePath = typeof mappaUrls[docInfo.storagePath] === 'string' ? mappaUrls[docInfo.storagePath] : mappaUrls[docInfo.storagePath].targetPath;
                    } else {
                        docInfo.storagePath = docInfo.storagePath.replace(/aree_riservate_clienti\/[^/]+/, `aree_riservate_clienti/${nuovoToken}`);
                    }
                }
            }

            // Inizializza il batch di scrittura atomico
            const batch = writeBatch(db);

            // 4. Elimina dal Limbo esterno (aree_riservate_clienti) il vecchio token
            batch.delete(vecchioTokenRef);

            // 5. Crea il nuovo token nella collezione esterna aree_riservate_clienti con i percorsi aggiornati
            const nuovoTokenRef = doc(db, 'aree_riservate_clienti', nuovoToken);
            batch.set(nuovoTokenRef, {
                token: nuovoToken,
                idCliente: Number(props.idCliente),
                idLavoro: Number(props.idLavoro),
                statoLavoro: "attivo",
                dataScadenza: scadenza,
                questionari: questionari,
                fasi: fasi,
                documentiCondivisi: documentiCondivisi,
                documentiRichiesti: {},
                documentiFineLavoro: {}
            });

            // 6. Aggiorna il documento del cliente
            const clienteRef = doc(db, 'clienti', String(props.idCliente));
            const percorsoCampoAttivo = `lavori.${props.idLavoro}._info.areaRiservataAttiva`;

            batch.update(clienteRef, {
                [percorsoCampoAttivo]: {
                    token: nuovoToken,
                    dataScadenza: scadenza,
                    statoLavoro: 'attivo'
                },
                modified: Timestamp.now()
            });

            await batch.commit();

            // 7. Aggiorna in RAM
            if (lavoroSelezionato.value?._info) {
                lavoroSelezionato.value._info.areaRiservataAttiva = {
                    token: nuovoToken,
                    dataScadenza: scadenza,
                    statoLavoro: 'attivo'
                };
            }

            alert('Nuovo codice generato con successo! I documenti sono stati spostati e il vecchio link non è più valido.');

        } catch (e) {
            console.error("Errore durante la rigenerazione dell'area:", e);
            alert("Errore durante la rigenerazione del codice.");
        } finally {
            caricamentoToken.value = false;
        }
    }

    async function modificaDataDisattivazione(nuovaData) {
        if (!areaRiservataAttiva.value?.token) return;
        if (!nuovaData) {
            alert("Inserire una data di disattivazione valida.");
            return;
        }

        let d;
        if (nuovaData.toDate && typeof nuovaData.toDate === 'function') {
            d = nuovaData.toDate();
        } else if (nuovaData.seconds) {
            d = new Date(nuovaData.seconds * 1000);
        } else {
            d = new Date(nuovaData);
        }

        if (isNaN(d.getTime())) {
            alert("Data di disattivazione non valida.");
            return;
        }

        // Imposta la scadenza a fine giornata (23:59:59.999) del giorno selezionato
        d.setHours(23, 59, 59, 999);
        const timestampFinale = Timestamp.fromDate(d);
        const token = areaRiservataAttiva.value.token;
        caricamentoToken.value = true;

        try {
            // 1. Aggiorna documento nella collezione esterna aree_riservate_clienti
            const areaRef = doc(db, 'aree_riservate_clienti', token);
            await updateDoc(areaRef, {
                dataScadenza: timestampFinale
            });

            // 2. Aggiorna il documento del cliente per sincronizzare i metadati su Firestore
            const clienteRef = doc(db, 'clienti', String(props.idCliente));
            const percorsoCampoAttivo = `lavori.${props.idLavoro}._info.areaRiservataAttiva.dataScadenza`;
            await updateDoc(clienteRef, {
                [percorsoCampoAttivo]: timestampFinale,
                modified: Timestamp.now()
            });

            // 3. Aggiorna lo stato in memoria locale per reattività immediata
            if (areaRiservataAttiva.value) {
                areaRiservataAttiva.value.dataScadenza = timestampFinale;
            }
            if (lavoroSelezionato.value?._info?.areaRiservataAttiva) {
                lavoroSelezionato.value._info.areaRiservataAttiva.dataScadenza = timestampFinale;
            }

            alert("Data di disattivazione aggiornata con successo!");
        } catch (e) {
            console.error("Errore aggiornamento data di disattivazione:", e);
            alert("Errore durante l'aggiornamento della data di disattivazione.");
        } finally {
            caricamentoToken.value = false;
        }
    }

    function formattaDataScadenza(dataScadenza) {
        if (!dataScadenza) return '';
        let date;
        if (dataScadenza.toDate && typeof dataScadenza.toDate === 'function') {
            date = dataScadenza.toDate();
        } else if (dataScadenza.seconds) {
            date = new Date(dataScadenza.seconds * 1000);
        } else if (dataScadenza._seconds) {
            date = new Date(dataScadenza._seconds * 1000);
        } else {
            date = new Date(dataScadenza);
        }
        return date.toLocaleDateString('it-IT');
    }

    function formattaData(data) {
        return formattaDataScadenza(data);
    }

    // Funzione contaCampiCompilati rimossa.

    // Sottoscrizione reattiva in tempo reale alla collezione esterna aree_riservate_clienti
    function attivaListenerAreaCliente() {
        if (!props.idLavoro) return;

        const q = query(
            collection(db, 'aree_riservate_clienti'),
            where('idLavoro', '==', Number(props.idLavoro))
        );

        unsubscribeAreaCliente = onSnapshot(q, (snapshot) => {
            const docArea = snapshot.docs[0];
            
            if (docArea) {
                const docData = docArea.data();
                // Pulizia automatica su Firestore e memoria del mockup legacy 'Raccolta Dati Anagrafici e Tecnici'
                if (docData.questionari) {
                    for (const [k, questObj] of Object.entries(docData.questionari)) {
                        if ((k === '1' || questObj.titolo === 'Raccolta Dati Anagrafici e Tecnici') && (!questObj.sezioni || questObj.sezioni.length === 0)) {
                            delete docData.questionari[k];
                            const areaRef = doc(db, 'aree_riservate_clienti', docArea.id);
                            updateDoc(areaRef, { [`questionari.${k}`]: deleteField() }).catch(console.error);
                        }
                    }
                }
                areaRiservataAttiva.value = {
                    token: docArea.id,
                    ...docData
                };
            } else {
                areaRiservataAttiva.value = null;
            }
        }, (error) => {
            console.error("Errore nel recupero real-time dell'area cliente:", error);
        });
    }

    // Rimozione sicura del listener per prevenire memory leak nelle single page application
    function disattivaListenerAreaCliente() {
        if (unsubscribeAreaCliente) {
            unsubscribeAreaCliente();
            unsubscribeAreaCliente = null;
        }
    }



    // LOGICA DI CONTROLLO INTERFACCIA ED OPERAZIONI AREA CLIENTE
    const subTabAreaCliente = ref('accesso');
    const questionarioApertoId = ref(null);
    const toggleQuestionarioAperto = (idQuest) => {
        questionarioApertoId.value = questionarioApertoId.value === idQuest ? null : idQuest;
    };
    const nuovoDocCondivisoTitolo = ref('');
    const fileCondivisoSelezionato = ref(null);
    const caricamentoUploadCondiviso = ref(false);

    const formattaNomeCampo = (str) => {
        if (!str) return '';
        const result = str.replace(/([A-Z])/g, " $1");
        const finalStr = result.charAt(0).toUpperCase() + result.slice(1);
        return finalStr.trim();
    };

    const formattaRispostaCampo = (info) => {
        if (!info || !info.txt) return 'Non compilato';
        
        // Formatta gli indirizzi
        if (typeof info.txt === 'object') {
            const val = info.txt;
            if (val.via || val.citta) {
                let parts = [];
                if (val.via) parts.push(val.via);
                let loc = [];
                if (val.cap) loc.push(val.cap);
                if (val.citta) loc.push(val.citta);
                if (val.prov) loc.push(val.prov);
                if (loc.length > 0) parts.push(loc.join(' '));
                
                return parts.join(', ');
            }
            return JSON.stringify(val);
        }
        
        if (info.tipo === 'data' && typeof info.txt === 'string') {
            const parts = info.txt.split('-');
            if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
        }
        
        if (info.tipo === 'iban' && typeof info.txt === 'string') {
            const clean = info.txt.replace(/\s+/g, '').toUpperCase();
            if (clean.length > 0) return clean.replace(/(.{4})/g, '$1 ').trim();
        }

        return info.txt;
    };

    const getCampiOrdinati = (campiObj) => {
        if (!campiObj) return [];
        return Object.entries(campiObj)
            .map(([nomeCampo, info], idx) => ({ nomeCampo, info, ordine: info.ordine !== undefined ? info.ordine : idx }))
            .sort((a, b) => a.ordine - b.ordine);
    };

    const getFileOrdinati = (fileObj) => {
        if (!fileObj) return [];
        return Object.entries(fileObj)
            .map(([chiaveFile, infoFile], idx) => ({ chiaveFile, infoFile, ordine: infoFile.ordine !== undefined ? infoFile.ordine : idx }))
            .sort((a, b) => a.ordine - b.ordine);
    };

    const isCampoVeramenteObbligatorio = (sez, nomeCampo, info) => {
        if (!info) return false;
        const isObblig = info.tipoObbligo ? info.tipoObbligo !== 'nessuno' : info.obbligatorio;
        if (!isObblig) return false;

        if (!sez || !sez.campi) return isObblig;

        const list = getCampiOrdinati(sez.campi);
        const idx = list.findIndex(item => item.nomeCampo === nomeCampo);
        if (idx === -1) return isObblig;

        // Determina se fa parte di un gruppo alternativo
        let start = idx;
        while (start > 0 && list[start - 1].info.tipoObbligo === 'alternativo') {
            start--;
        }
        let end = idx;
        while (end < list.length - 1 && list[end].info.tipoObbligo === 'alternativo') {
            end++;
        }

        // Se fa parte di un gruppo alternativo, non è un obbligo isolato/assoluto
        if (start < end) {
            return false;
        }

        return isObblig;
    };

    function getTimestampMillis(ts) {
        if (!ts) return 0;
        if (typeof ts.toMillis === 'function') return ts.toMillis();
        if (typeof ts.toDate === 'function') return ts.toDate().getTime();
        if (ts.seconds !== undefined) return ts.seconds * 1000 + (ts.nanoseconds || 0) / 1e6;
        if (ts._seconds !== undefined) return ts._seconds * 1000 + (ts._nanoseconds || 0) / 1e6;
        const d = new Date(ts);
        return isNaN(d.getTime()) ? 0 : d.getTime();
    }

    // Questionari ordinati: prima i non compilati, seguiti dai compilati in ordine di data/ora di compilazione
    const questionariOrdinati = computed(() => {
        if (!areaRiservataAttiva.value?.questionari) return [];
        const lista = Object.entries(areaRiservataAttiva.value.questionari)
            .filter(([idQuest, quest]) => {
                if ((idQuest === '1' || quest.titolo === 'Raccolta Dati Anagrafici e Tecnici') && (!quest.sezioni || quest.sezioni.length === 0)) {
                    return false;
                }
                return true;
            })
            .map(([idQuest, quest]) => ({
                idQuest,
                quest
            }));

        return lista.sort((a, b) => {
            const aCompilato = a.quest.stato === 'compilato';
            const bCompilato = b.quest.stato === 'compilato';

            // 1. I questionari non compilati (locale, bozza, inviato) prima dei compilati
            if (!aCompilato && bCompilato) return -1;
            if (aCompilato && !bCompilato) return 1;

            // 2. Seguiti dai questionari compilati in ordine di data e ora di compilazione inversa (più recenti in alto)
            if (aCompilato && bCompilato) {
                const timeA = getTimestampMillis(a.quest.dataCompilazione);
                const timeB = getTimestampMillis(b.quest.dataCompilazione);
                if (timeA !== timeB) return timeB - timeA;
                return b.idQuest.localeCompare(a.idQuest);
            }

            // 3. Tra i non compilati, mantieni ordine stabile
            const timeInvioA = getTimestampMillis(a.quest.dataInvio);
            const timeInvioB = getTimestampMillis(b.quest.dataInvio);
            if (timeInvioA !== timeInvioB) return timeInvioA - timeInvioB;
            return a.idQuest.localeCompare(b.idQuest);
        });
    });

    // Questionari
    const nuovoQuestionarioTemplateKey = ref('');


    const sezioneVisibile = (quest, sezIndex) => {
        const sez = quest.sezioni[sezIndex];
        if (!sez.condizioneAttivazione || !sez.condizioneAttivazione.abilitata) return true;
        
        const targetCampoId = sez.condizioneAttivazione.campoId;
        if (!targetCampoId) return true;

        const opzioneSpecifica = (sez.condizioneAttivazione.opzioneSelezionata || '').trim();

        for (let i = 0; i < sezIndex; i++) {
            const pSez = quest.sezioni[i];
            if (pSez.campi && pSez.campi[targetCampoId]) {
                const val = pSez.campi[targetCampoId].txt;
                
                if (Array.isArray(val)) {
                    if (opzioneSpecifica) return val.some(v => v.trim() === opzioneSpecifica);
                    return val.length > 0;
                }
                
                if (typeof val === 'string') {
                    if (pSez.campi[targetCampoId].tipo === 'accettazione') return val === 'accetto';
                    if (opzioneSpecifica) return val.trim() === opzioneSpecifica;
                    return val.trim() !== '';
                }
                
                if (typeof val === 'boolean') return val;
            }
        }
        return false;
    };

    const deveMostrareSezione = (quest, sezIndex) => {
        if (quest.stato === 'locale' || quest.stato === 'bozza' || quest.stato === 'inviato') return true; 
        return sezioneVisibile(quest, sezIndex);
    };

    const getCampiPrecedentiQuestionario = (quest, currentIndex) => {
        if (!quest || !quest.sezioni) return [];
        const list = [];
        for (let i = 0; i < currentIndex; i++) {
            const sez = quest.sezioni[i];
            if (sez.campi) {
                for (const [key, campo] of Object.entries(sez.campi)) {
                    if (campo.tipo === 'checkbox_multiplo' || campo.tipo === 'accettazione') {
                        list.push({ 
                            id: key, 
                            label: campo.label || key, 
                            tipo: campo.tipo, 
                            opzioniStr: campo.opzioniStr || '' 
                        });
                    }
                }
            }
        }
        return list;
    };

    const importaQuestionario = () => {
        const tplKey = nuovoQuestionarioTemplateKey.value;
        if (!tplKey || !areaRiservataAttiva.value?.token) return;
        
        const template = impostazioniGenerali.value.questionariPredefiniti[tplKey];
        if (!template) return;

        const nuovoQuest = {
            titolo: template.titolo,
            stato: 'locale',
            sezioni: []
        };

        // Deep clone sections
        if (template.sezioni) {
            const sezioniClonate = JSON.parse(JSON.stringify(template.sezioni));
            
            // Initialize answers and normalize field orders
            for (const sez of sezioniClonate) {
                // Auto-migrazione vecchi documenti (sez.file -> sez.campi con tipo: 'file')
                if (sez.file && Object.keys(sez.file).length > 0) {
                    if (!sez.campi) sez.campi = {};
                    const maxOrder = Object.values(sez.campi).reduce((max, c) => Math.max(max, c.ordine ?? 0), -1);
                    let offset = 1;
                    for (const [fKey, fVal] of Object.entries(sez.file)) {
                        const newKey = fKey.startsWith('campo_') ? fKey : ('campo_' + fKey);
                        if (!sez.campi[newKey]) {
                            sez.campi[newKey] = {
                                label: fVal.label || fKey,
                                tipo: 'file',
                                obbligatorio: !!fVal.obbligatorio,
                                tipoObbligo: fVal.obbligatorio ? 'assoluto' : 'nessuno',
                                url: null,
                                txt: '',
                                ordine: maxOrder + offset
                            };
                            offset++;
                        }
                    }
                    delete sez.file;
                }

                if (sez.campi) {
                    const list = Object.entries(sez.campi)
                        .map(([k, c], idx) => ({ k, c, ord: c.ordine !== undefined ? c.ordine : idx }))
                        .sort((a, b) => a.ord - b.ord);

                    list.forEach((item, idx) => {
                        const value = item.c;
                        value.ordine = idx;
                        if (!value.tipoObbligo) {
                            value.tipoObbligo = value.obbligatorio ? 'assoluto' : 'nessuno';
                        }
                        const tipo = value.tipo || 'stringa';
                        let initialTxt = '';
                        if (tipo === 'accettazione') initialTxt = '';
                        else if (tipo === 'checkbox_multiplo') initialTxt = value.txt || '';
                        else if (tipo === 'indirizzo') initialTxt = { via: '', cap: '', citta: '', prov: '' };
                        else if (tipo === 'file') {
                            initialTxt = '';
                            value.url = null;
                        }
                        
                        value.txt = initialTxt;
                    });
                }
            }
            nuovoQuest.sezioni = sezioniClonate;
        }

        const questId = 'quest_' + Date.now();
        if (!areaRiservataAttiva.value.questionari) {
            areaRiservataAttiva.value.questionari = {};
        }
        areaRiservataAttiva.value.questionari[questId] = nuovoQuest;

        nuovoQuestionarioTemplateKey.value = '';
    };

    const rimuoviSezione = (idQuest, sIndex) => {
        if (!confirm("Sei sicuro di voler rimuovere questa sezione? I dati inseriti andranno persi.")) return;
        const questCorrente = areaRiservataAttiva.value.questionari[idQuest];
        questCorrente.sezioni.splice(sIndex, 1);
    };

    const spostaSezione = (idQuest, index, dir) => {
        const questCorrente = areaRiservataAttiva.value.questionari[idQuest];
        const sezioniAttuali = questCorrente.sezioni;
        
        if (index + dir < 0 || index + dir >= sezioniAttuali.length) return;

        const temp = sezioniAttuali[index];
        sezioniAttuali[index] = sezioniAttuali[index + dir];
        sezioniAttuali[index + dir] = temp;
    };

    const haCampiOFile = (quest) => {
        if (!quest.sezioni || quest.sezioni.length === 0) return false;
        for (const sez of quest.sezioni) {
            if (sez.campi && Object.keys(sez.campi).length > 0) return true;
            if (sez.file && Object.keys(sez.file).length > 0) return true;
        }
        return false;
    };

    const salvaQuestionario = async (idQuest, quest, statoDesiderato) => {
        if (!areaRiservataAttiva.value?.token) return;
        const token = areaRiservataAttiva.value.token;

        // Se stiamo inviando per la prima volta, settiamo dataInvio
        if (statoDesiderato === 'inviato' && quest.stato !== 'inviato' && quest.stato !== 'compilato') {
            quest.dataInvio = Timestamp.now();
        }
        quest.stato = statoDesiderato;

        try {
            const areaRef = doc(db, 'aree_riservate_clienti', token);
            await updateDoc(areaRef, {
                [`questionari.${idQuest}`]: quest
            });
            await updateDoc(doc(db, 'clienti', String(props.idCliente)), {
                modified: Timestamp.now()
            });
            alert("Salvataggio completato con successo.");
        } catch (e) {
            console.error("Errore salvataggio questionario:", e);
            alert("Errore durante il salvataggio.");
        }
    };

    const incollaStrutturaQuestionario = (idQuest) => {
        if (!copiaTrasporto.value.strutturaQuestionario) {
            alert("Nessuna struttura questionario negli appunti!");
            return;
        }
        if (!confirm("Verranno incollate le sezioni copiate. Eventuali sezioni esistenti rimarranno. Procedere?")) return;
        const questCorrente = areaRiservataAttiva.value.questionari[idQuest];
        if (!questCorrente.sezioni) questCorrente.sezioni = [];
        const sezioniCopiate = JSON.parse(JSON.stringify(copiaTrasporto.value.strutturaQuestionario));
        questCorrente.sezioni.push(...sezioniCopiate);
    };

    const copiaStrutturaQuestionario = (quest) => {
        if (!quest.sezioni || quest.sezioni.length === 0) {
            alert("Il questionario non ha sezioni da copiare.");
            return;
        }
        const sezioniPulite = JSON.parse(JSON.stringify(quest.sezioni)).map(sez => {
            if (sez.campi) {
                for (const key in sez.campi) {
                    sez.campi[key].txt = '';
                }
            }
            if (sez.file) {
                for (const key in sez.file) {
                    sez.file[key].url = null;
                }
            }
            return sez;
        });
        copiaTrasporto.value.strutturaQuestionario = sezioniPulite;
        alert("Struttura questionario copiata negli appunti!");
    };

    const annullaModificheQuestionario = (idQuest) => {
        if (!confirm("Sei sicuro di voler annullare le modifiche non salvate?")) return;
        const quest = areaRiservataAttiva.value.questionari[idQuest];
        if (quest.stato === 'locale') {
            delete areaRiservataAttiva.value.questionari[idQuest];
        } else {
            const originale = dbClienti.value[props.idCliente]?.lavori[props.idLavoro]?._info?.areaRiservataAttiva?.questionari?.[idQuest];
            if (originale) {
                areaRiservataAttiva.value.questionari[idQuest] = JSON.parse(JSON.stringify(originale));
            } else {
                delete areaRiservataAttiva.value.questionari[idQuest];
            }
        }
    };

    const rilanciaQuestionario = (idQuest) => {
        const questCorrente = areaRiservataAttiva.value.questionari[idQuest];
        if (!questCorrente) return;

        const nuovoQuest = {
            titolo: (questCorrente.titolo || 'Questionario') + ' (Rilanciato)',
            stato: 'locale',
            sezioni: []
        };

        if (questCorrente.sezioni && questCorrente.sezioni.length > 0) {
            // Mantiene la struttura completa e i dati precompilati (txt dei campi e url dei file)
            nuovoQuest.sezioni = JSON.parse(JSON.stringify(questCorrente.sezioni));
        } else if (questCorrente.campi || questCorrente.file) {
            // Supporto questionari legacy
            nuovoQuest.sezioni = [
                {
                    titolo: questCorrente.titolo || '',
                    campi: questCorrente.campi ? JSON.parse(JSON.stringify(questCorrente.campi)) : {},
                    file: questCorrente.file ? JSON.parse(JSON.stringify(questCorrente.file)) : {}
                }
            ];
        }

        const nuovoIdQuest = 'quest_' + Date.now();
        if (!areaRiservataAttiva.value.questionari) areaRiservataAttiva.value.questionari = {};
        areaRiservataAttiva.value.questionari[nuovoIdQuest] = nuovoQuest;
    };

    const rimuoviQuestionario = async (idQuest, saltaConferma = false) => {
        if (!areaRiservataAttiva.value?.token) return;
        if (!saltaConferma && !confirm("Sei sicuro di voler rimuovere questo questionario? Tutti i dati andranno persi.")) return;

        const quest = areaRiservataAttiva.value.questionari[idQuest];

        // 1. Elimina da Firebase Storage tutti i documenti e file caricati dal cliente in questo questionario
        if (quest && quest.sezioni) {
            for (const sez of quest.sezioni) {
                if (sez.campi) {
                    for (const key in sez.campi) {
                        const campo = sez.campi[key];
                        if (campo.tipo === 'file') {
                            const pathOrUrl = campo.storagePath || campo.url;
                            if (pathOrUrl) {
                                await eliminaFileDaStorage(pathOrUrl);
                            }
                        }
                    }
                }
                if (sez.file) {
                    for (const key in sez.file) {
                        const f = sez.file[key];
                        const pathOrUrl = f.storagePath || f.url;
                        if (pathOrUrl) {
                            await eliminaFileDaStorage(pathOrUrl);
                        }
                    }
                }
            }
        }

        if (quest && quest.stato === 'locale') {
            delete areaRiservataAttiva.value.questionari[idQuest];
            if (!saltaConferma) alert('Questionario rimosso con successo.');
            return;
        }

        const token = areaRiservataAttiva.value.token;
        try {
            const areaRef = doc(db, 'aree_riservate_clienti', token);
            await updateDoc(areaRef, {
                [`questionari.${idQuest}`]: deleteField()
            });
            await updateDoc(doc(db, 'clienti', String(props.idCliente)), {
                modified: Timestamp.now()
            });
            if (!saltaConferma) alert('Questionario rimosso con successo.');
        } catch (e) {
            console.error("Errore rimozione questionario:", e);
            alert("Errore durante la rimozione del questionario.");
        }
    };

    const richiediEliminazioneQuestionario = (idQuest) => {
        messaggioModale.value = {
            testoLight: { testo: 'Annulla', comando: 'annulla' },
            testoDanger: { testo: 'Elimina', comando: 'eliminaQuestionario_' + idQuest },
            messaggio: 'Sei sicuro di eliminare il questionario? Tutti i dati andranno persi.'
        };
    };

    // Documenti Condivisi
    const selezionaFileCondiviso = (event) => {
        fileCondivisoSelezionato.value = event.target.files[0];
    };

    const caricaDocumentoCondiviso = async () => {
        if (!fileCondivisoSelezionato.value || !nuovoDocCondivisoTitolo.value || !areaRiservataAttiva.value?.token) return;

        caricamentoUploadCondiviso.value = true;
        const token = areaRiservataAttiva.value.token;
        const file = fileCondivisoSelezionato.value;
        const percorso = `aree_riservate_clienti/${token}/documenti_condivisi/${Date.now()}_${file.name}`;

        try {
            const fileRef = storageRef(storageInstance, percorso);
            await uploadBytes(fileRef, file);
            const downloadUrl = await getDownloadURL(fileRef);

            const areaRef = doc(db, 'aree_riservate_clienti', token);
            const docKey = 'doc_' + Date.now();
            const nuovoDoc = {
                nome: nuovoDocCondivisoTitolo.value.trim(),
                url: downloadUrl,
                dataCaricamento: Timestamp.now(),
                storagePath: percorso,
                visualizzato: false
            };

            await updateDoc(areaRef, {
                [`documentiCondivisi.${docKey}`]: nuovoDoc
            });

            await updateDoc(doc(db, 'clienti', String(props.idCliente)), {
                modified: Timestamp.now()
            });

            nuovoDocCondivisoTitolo.value = '';
            fileCondivisoSelezionato.value = null;
            alert('Documento caricato e condiviso con successo!');
        } catch (e) {
            console.error("Errore caricamento documento condiviso:", e);
            alert("Errore durante il caricamento del documento.");
        } finally {
            caricamentoUploadCondiviso.value = false;
        }
    };

    const eliminaDocumentoCondiviso = async (docKey) => {
        if (!areaRiservataAttiva.value?.token) return;
        const docInfo = areaRiservataAttiva.value.documentiCondivisi[docKey];
        if (!docInfo) return;

        if (!confirm(`Sei sicuro di voler eliminare e smettere di condividere il documento "${docInfo.nome}"?`)) return;

        const token = areaRiservataAttiva.value.token;
        try {
            if (docInfo.storagePath) {
                const fileRef = storageRef(storageInstance, docInfo.storagePath);
                await deleteObject(fileRef).catch(err => console.warn("File storage non trovato o già eliminato:", err));
            }

            const areaRef = doc(db, 'aree_riservate_clienti', token);
            await updateDoc(areaRef, {
                [`documentiCondivisi.${docKey}`]: deleteField()
            });

            await updateDoc(doc(db, 'clienti', String(props.idCliente)), {
                modified: Timestamp.now()
            });

            alert('Documento eliminato.');
        } catch (e) {
            console.error("Errore eliminazione documento condiviso:", e);
            alert("Errore durante l'eliminazione del documento.");
        }
    };

    // Fasi Cliente
    const fasiClienteOrdinate = computed(() => {
        if (!areaRiservataAttiva.value?.fasi) return [];
        return Object.entries(areaRiservataAttiva.value.fasi)
            .map(([key, value]) => ({ key, ...value }))
            .sort((a, b) => (a.ordine ?? 0) - (b.ordine ?? 0));
    });

    const aggiungiNuovaFaseCliente = async () => {
        if (!areaRiservataAttiva.value?.token) return;
        const token = areaRiservataAttiva.value.token;
        
        const maxOrdine = fasiClienteOrdinate.value.reduce((max, f) => Math.max(max, f.ordine ?? 0), -1);

        const nuovaFase = {
            descrizione: 'Nuova lavorazione cantiere',
            dataInizio: '',
            statoInizio: 'stimata',
            dataFine: '',
            statoFine: 'stimata',
            percentuale: 0,
            visibilePercentuale: 'visibile',
            ordine: maxOrdine + 1
        };

        const faseKey = 'fase_' + Date.now();

        try {
            const areaRef = doc(db, 'aree_riservate_clienti', token);
            await updateDoc(areaRef, {
                [`fasi.${faseKey}`]: nuovaFase
            });
            await updateDoc(doc(db, 'clienti', String(props.idCliente)), {
                modified: Timestamp.now()
            });
        } catch (e) {
            console.error("Errore aggiunta fase cliente:", e);
            alert("Errore durante l'aggiunta della fase.");
        }
    };

    const salvaFaseCliente = async (faseKey, fase) => {
        if (!areaRiservataAttiva.value?.token) return;
        const token = areaRiservataAttiva.value.token;
        
        try {
            const areaRef = doc(db, 'aree_riservate_clienti', token);
            await updateDoc(areaRef, {
                [`fasi.${faseKey}`]: {
                    descrizione: fase.descrizione || '',
                    dataInizio: fase.dataInizio || '',
                    statoInizio: fase.statoInizio || 'stimata',
                    dataFine: fase.dataFine || '',
                    statoFine: fase.statoFine || 'stimata',
                    percentuale: parseInt(fase.percentuale) || 0,
                    visibilePercentuale: fase.visibilePercentuale || 'visibile',
                    ordine: fase.ordine ?? 0
                }
            });
            await updateDoc(doc(db, 'clienti', String(props.idCliente)), {
                modified: Timestamp.now()
            });
        } catch (e) {
            console.error("Errore salvataggio fase cliente:", e);
        }
    };

    const rimuoviFaseCliente = async (faseKey) => {
        if (!areaRiservataAttiva.value?.token) return;
        if (!confirm("Sei sicuro di voler eliminare questa fase visibile al cliente?")) return;

        const token = areaRiservataAttiva.value.token;
        try {
            const areaRef = doc(db, 'aree_riservate_clienti', token);
            await updateDoc(areaRef, {
                [`fasi.${faseKey}`]: deleteField()
            });
            await updateDoc(doc(db, 'clienti', String(props.idCliente)), {
                modified: Timestamp.now()
            });
        } catch (e) {
            console.error("Errore rimozione fase cliente:", e);
            alert("Errore durante la rimozione della fase.");
        }
    };

    const spostaFaseCliente = async (faseKey, direzione) => {
        if (!areaRiservataAttiva.value?.token) return;
        const token = areaRiservataAttiva.value.token;

        const lista = [...fasiClienteOrdinate.value];
        const index = lista.findIndex(f => f.key === faseKey);
        if (index === -1) return;

        const nuovoIndex = index + direzione;
        if (nuovoIndex < 0 || nuovoIndex >= lista.length) return;

        const f1 = lista[index];
        const f2 = lista[nuovoIndex];
        const tempOrdine = f1.ordine;
        f1.ordine = f2.ordine;
        f2.ordine = tempOrdine;

        try {
            const areaRef = doc(db, 'aree_riservate_clienti', token);
            await updateDoc(areaRef, {
                [`fasi.${f1.key}.ordine`]: f1.ordine,
                [`fasi.${f2.key}.ordine`]: f2.ordine
            });
            await updateDoc(doc(db, 'clienti', String(props.idCliente)), {
                modified: Timestamp.now()
            });
        } catch (e) {
            console.error("Errore spostamento fase cliente:", e);
        }
    };

    // Gestione del Lifecycle Hook di Vue 3
    onMounted(() => {
        attivaListenerAreaCliente();
    });

    onUnmounted(() => {
        disattivaListenerAreaCliente();
    });

</script>